/**
 * Generated from ZoraHurstonStoryLayout.fla
 */
export function ZoraHurstonStoryLayout(this: IZoraHurstonStoryLayout) {
	const scene1Start = this.scene1Start;
	ZoraHurstonStoryLayout_scene1Start.call(this.scene1Start);
	scene1Start.x = 0;
	scene1Start.y = 0;
	if (scene1Start.onLayout) scene1Start.onLayout();
	const scene2Encounter = this.scene2Encounter;
	ZoraHurstonStoryLayout_scene2Encounter.call(this.scene2Encounter);
	scene2Encounter.x = 0;
	scene2Encounter.y = 0;
	if (scene2Encounter.onLayout) scene2Encounter.onLayout();
	const scene3Reaction = this.scene3Reaction;
	ZoraHurstonStoryLayout_scene3Reaction.call(this.scene3Reaction);
	scene3Reaction.x = 0;
	scene3Reaction.y = 0;
	if (scene3Reaction.onLayout) scene3Reaction.onLayout();
	const scene4Help = this.scene4Help;
	ZoraHurstonStoryLayout_scene4Help.call(this.scene4Help);
	scene4Help.x = 0;
	scene4Help.y = 0;
	if (scene4Help.onLayout) scene4Help.onLayout();
	const scene5Result = this.scene5Result;
	ZoraHurstonStoryLayout_scene5Result.call(this.scene5Result);
	scene5Result.x = 0;
	scene5Result.y = 0;
	if (scene5Result.onLayout) scene5Result.onLayout();
	const scene6End = this.scene6End;
	ZoraHurstonStoryLayout_scene6End.call(this.scene6End);
	scene6End.x = 0;
	scene6End.y = 0;
	if (scene6End.onLayout) scene6End.onLayout();
	return this;
}
export function ZoraHurstonStoryLayout_scene1Start(this: IZoraHurstonStoryLayout_scene1Start) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[0].x = 440;
		items[0].y = 133;
		items[0].width = 1391.90;
		items[0].height = 813.30;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[1] as IZoraHurstonStoryLayout_paperLayer);
		(items[1] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"classroom"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotClassroom.call(items[2] as IZoraHurstonStoryLayout_slotClassroom);
		(items[2] as IZoraHurstonStoryLayout_slotClassroom).option = "classroom";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurPlayground11.call(items[3] as IZoraHurstonStoryLayout_hurPlayground11);
		(items[3] as IZoraHurstonStoryLayout_hurPlayground11).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurPlayground11).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurPlayground11).option = "playground";
		items[3].x = 0;
		items[3].y = 0;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"squishStretch","isButton":true,"option":"kidzone"});
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_hurKidzone.call(items[4] as IZoraHurstonStoryLayout_hurKidzone);
		(items[4] as IZoraHurstonStoryLayout_hurKidzone).animation = "squishStretch";
		(items[4] as IZoraHurstonStoryLayout_hurKidzone).isButton = true;
		(items[4] as IZoraHurstonStoryLayout_hurKidzone).option = "kidzone";
		items[4].x = 1083.3;
		items[4].y = 1148;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"","isButton":false,"option":"dinosaur"});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_hurDinosaur.call(items[5] as IZoraHurstonStoryLayout_hurDinosaur);
		(items[5] as IZoraHurstonStoryLayout_hurDinosaur).animation = "";
		(items[5] as IZoraHurstonStoryLayout_hurDinosaur).isButton = false;
		(items[5] as IZoraHurstonStoryLayout_hurDinosaur).option = "dinosaur";
		items[5].x = 1024.8;
		items[5].y = 1044.5;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"isPaperLayer":true});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[6] as IZoraHurstonStoryLayout_paperLayer);
		(items[6] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[6].x = 0;
		items[6].y = 0;
		items[6].width = 2048.00;
		items[6].height = 1536.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch appear delay=0.4","isButton":true,"option":"classroom"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_hurBSitdraw1.call(items[7] as IZoraHurstonStoryLayout_hurBSitdraw1);
		(items[7] as IZoraHurstonStoryLayout_hurBSitdraw1).animation = "squishStretch appear delay=0.4";
		(items[7] as IZoraHurstonStoryLayout_hurBSitdraw1).isButton = true;
		(items[7] as IZoraHurstonStoryLayout_hurBSitdraw1).option = "classroom";
		items[7].x = 551.1;
		items[7].y = 1097.2;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"playground"});
	}
	if (items[8]) {
		ZoraHurstonStoryLayout_hurBSitdraw1.call(items[8] as IZoraHurstonStoryLayout_hurBSitdraw1);
		(items[8] as IZoraHurstonStoryLayout_hurBSitdraw1).animation = "squishStretch appear delay=0.2";
		(items[8] as IZoraHurstonStoryLayout_hurBSitdraw1).isButton = true;
		(items[8] as IZoraHurstonStoryLayout_hurBSitdraw1).option = "playground";
		items[8].x = 567.25;
		items[8].y = 1104.8;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"kidzone"});
	}
	if (items[9]) {
		ZoraHurstonStoryLayout_hurBSitdraw1.call(items[9] as IZoraHurstonStoryLayout_hurBSitdraw1);
		(items[9] as IZoraHurstonStoryLayout_hurBSitdraw1).animation = "squishStretch appear delay=0.2";
		(items[9] as IZoraHurstonStoryLayout_hurBSitdraw1).isButton = true;
		(items[9] as IZoraHurstonStoryLayout_hurBSitdraw1).option = "kidzone";
		items[9].x = 588.25;
		items[9].y = 921.7;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"dinosaur"});
	}
	if (items[10]) {
		ZoraHurstonStoryLayout_hurBSitdraw1.call(items[10] as IZoraHurstonStoryLayout_hurBSitdraw1);
		(items[10] as IZoraHurstonStoryLayout_hurBSitdraw1).animation = "squishStretch appear delay=0.2";
		(items[10] as IZoraHurstonStoryLayout_hurBSitdraw1).isButton = true;
		(items[10] as IZoraHurstonStoryLayout_hurBSitdraw1).option = "dinosaur";
		items[10].x = 911.4;
		items[10].y = 921.8;
		if (items[10].onLayout) items[10].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlaygroundBg(this: IZoraHurstonStoryLayout_hurPlaygroundBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-bg.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_paperLayer(this: IZoraHurstonStoryLayout_paperLayer) {
	return this;
}
function ZoraHurstonStoryLayout_slotClassroom(this: IZoraHurstonStoryLayout_slotClassroom) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp time=0.6","isButton":true,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotChalkboard.call(items[0] as IZoraHurstonStoryLayout_slotChalkboard);
		(items[0] as IZoraHurstonStoryLayout_slotChalkboard).animation = "scaleUp time=0.6";
		(items[0] as IZoraHurstonStoryLayout_slotChalkboard).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_slotChalkboard).option = "";
		items[0].x = 1024.7;
		items[0].y = 504.3;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn right delay=0.4 time=0.4 ease=backOut","isButton":false,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurClassroomChair.call(items[1] as IZoraHurstonStoryLayout_hurClassroomChair);
		(items[1] as IZoraHurstonStoryLayout_hurClassroomChair).animation = "slideIn right delay=0.4 time=0.4 ease=backOut";
		(items[1] as IZoraHurstonStoryLayout_hurClassroomChair).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurClassroomChair).option = "";
		items[1].x = 1551.85;
		items[1].y = 519.7;
		items[1].width = 258.00;
		items[1].height = 245.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"slideIn right delay=0.4 time=0.4 ease=backOut","isButton":true,"option":""});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotDesk.call(items[2] as IZoraHurstonStoryLayout_slotDesk);
		(items[2] as IZoraHurstonStoryLayout_slotDesk).animation = "slideIn right delay=0.4 time=0.4 ease=backOut";
		(items[2] as IZoraHurstonStoryLayout_slotDesk).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotDesk).option = "";
		items[2].x = 1556.3;
		items[2].y = 807.85;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"slideIn right delay=0.4 time=0.4 ease=backOut","isButton":true,"option":""});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_slotPlant.call(items[3] as IZoraHurstonStoryLayout_slotPlant);
		(items[3] as IZoraHurstonStoryLayout_slotPlant).animation = "slideIn right delay=0.4 time=0.4 ease=backOut";
		(items[3] as IZoraHurstonStoryLayout_slotPlant).isButton = true;
		(items[3] as IZoraHurstonStoryLayout_slotPlant).option = "";
		items[3].x = 1934.75;
		items[3].y = 1003.15;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotChalkboard(this: IZoraHurstonStoryLayout_slotChalkboard) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurClassroomChalkboard.call(items[0] as IZoraHurstonStoryLayout_hurClassroomChalkboard);
		items[0].x = -509.5;
		items[0].y = -240;
		items[0].width = 1019.00;
		items[0].height = 480.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurClassroomChalkboard(this: IZoraHurstonStoryLayout_hurClassroomChalkboard) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-chalkboard.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurClassroomChair(this: IZoraHurstonStoryLayout_hurClassroomChair) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-chair.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_slotDesk(this: IZoraHurstonStoryLayout_slotDesk) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurClassroomDesk.call(items[0] as IZoraHurstonStoryLayout_hurClassroomDesk);
		items[0].x = -340;
		items[0].y = -122.85;
		items[0].width = 680.00;
		items[0].height = 411.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurClassroomDesk(this: IZoraHurstonStoryLayout_hurClassroomDesk) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-desk.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_slotPlant(this: IZoraHurstonStoryLayout_slotPlant) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurClassroomPlant.call(items[0] as IZoraHurstonStoryLayout_hurClassroomPlant);
		items[0].x = -146.5;
		items[0].y = -191.5;
		items[0].width = 293.00;
		items[0].height = 383.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurClassroomPlant(this: IZoraHurstonStoryLayout_hurClassroomPlant) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-classroom-plant.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurPlayground11(this: IZoraHurstonStoryLayout_hurPlayground11) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBench1.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1).animation = "squishStretch";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1).option = "";
		items[0].x = 328;
		items[0].y = 923;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":true,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurPlaygroundStructure1.call(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1);
		(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1).animation = "squishStretch";
		(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1).option = "";
		items[1].x = 1050;
		items[1].y = 1010;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"rotate yoyo speed=-30 repeat=3 time=0.2 delay=0.4","isButton":true,"option":"playground"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurPlaygroundDuck.call(items[2] as IZoraHurstonStoryLayout_hurPlaygroundDuck);
		(items[2] as IZoraHurstonStoryLayout_hurPlaygroundDuck).animation = "rotate yoyo speed=-30 repeat=3 time=0.2 delay=0.4";
		(items[2] as IZoraHurstonStoryLayout_hurPlaygroundDuck).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_hurPlaygroundDuck).option = "playground";
		items[2].x = 1395.05;
		items[2].y = 1138.15;
		items[2].rotation = 0.2618;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlaygroundBench1(this: IZoraHurstonStoryLayout_hurPlaygroundBench1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBench.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 470.00;
		items[0].height = 48.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlaygroundBench(this: IZoraHurstonStoryLayout_hurPlaygroundBench) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-bench.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurPlaygroundStructure1(this: IZoraHurstonStoryLayout_hurPlaygroundStructure1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundStructure.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundStructure);
		items[0].x = -362.5;
		items[0].y = -843;
		items[0].width = 725.00;
		items[0].height = 843.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlaygroundStructure(this: IZoraHurstonStoryLayout_hurPlaygroundStructure) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-structure.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurPlaygroundDuck(this: IZoraHurstonStoryLayout_hurPlaygroundDuck) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch appear delay=0.4 time=1.4","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlayground1.call(items[0] as IZoraHurstonStoryLayout_hurPlayground1);
		(items[0] as IZoraHurstonStoryLayout_hurPlayground1).animation = "squishStretch appear delay=0.4 time=1.4";
		(items[0] as IZoraHurstonStoryLayout_hurPlayground1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlayground1).option = "";
		items[0].x = -50.4;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlayground1(this: IZoraHurstonStoryLayout_hurPlayground1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlayground2.call(items[0] as IZoraHurstonStoryLayout_hurPlayground2);
		items[0].x = 0;
		items[0].y = -206;
		items[0].width = 370.00;
		items[0].height = 413.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlayground2(this: IZoraHurstonStoryLayout_hurPlayground2) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-playground-front.png", 0.500, 0.501);
	return this;
}
function ZoraHurstonStoryLayout_hurKidzone(this: IZoraHurstonStoryLayout_hurKidzone) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurKidzone1.call(items[0] as IZoraHurstonStoryLayout_hurKidzone1);
		items[0].x = 0;
		items[0].y = -299.5;
		items[0].width = 1323.00;
		items[0].height = 599.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurKidzone1(this: IZoraHurstonStoryLayout_hurKidzone1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-kidzone.png", 0.500, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_hurDinosaur(this: IZoraHurstonStoryLayout_hurDinosaur) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"slideIn up time=0.4 ease=backOut","isButton":true,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDinosaur1.call(items[0] as IZoraHurstonStoryLayout_hurDinosaur1);
		(items[0] as IZoraHurstonStoryLayout_hurDinosaur1).animation = "slideIn up time=0.4 ease=backOut";
		(items[0] as IZoraHurstonStoryLayout_hurDinosaur1).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_hurDinosaur1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn down time=0.4 delay=0.2 ease=backOut","isButton":true,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl.call(items[1] as IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl);
		(items[1] as IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl).animation = "slideIn down time=0.4 delay=0.2 ease=backOut";
		(items[1] as IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl).option = "";
		items[1].x = -814.15;
		items[1].y = -642.65;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDinosaur1(this: IZoraHurstonStoryLayout_hurDinosaur1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDinosaur2.call(items[0] as IZoraHurstonStoryLayout_hurDinosaur2);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 1732.00;
		items[0].height = 779.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDinosaur2(this: IZoraHurstonStoryLayout_hurDinosaur2) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-dinosaur.png", 0.500, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl(this: IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl1.call(items[0] as IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl1);
		items[0].x = 307;
		items[0].y = -224.5;
		items[0].width = 614.00;
		items[0].height = 449.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl1(this: IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-dinosaurexhibit-pterodactyl.png", 0.500, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_hurBSitdraw1(this: IZoraHurstonStoryLayout_hurBSitdraw1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSitdraw.call(items[0] as IZoraHurstonStoryLayout_hurBSitdraw);
		items[0].x = -148;
		items[0].y = -450;
		items[0].width = 296.00;
		items[0].height = 450.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSitdraw(this: IZoraHurstonStoryLayout_hurBSitdraw) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sitdraw.png", 0.000, 0.000);
	return this;
}
export function ZoraHurstonStoryLayout_scene2Encounter(this: IZoraHurstonStoryLayout_scene2Encounter) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[0].x = 440;
		items[0].y = 133;
		items[0].width = 1391.90;
		items[0].height = 813.30;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"from kidzoneMonsterStart id=kidzoneMonster time=0.6 ease=backOut","isButton":true,"option":"kidzone"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneAnim.call(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim);
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).animation = "from kidzoneMonsterStart id=kidzoneMonster time=0.6 ease=backOut";
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).option = "kidzone";
		items[1].x = 1440.5;
		items[1].y = 952.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"from dinosaurMonsterStart id=dinosaurMonster time=0.6 ease=backOut","isButton":true,"option":"dinosaur"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurAnim.call(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim);
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).animation = "from dinosaurMonsterStart id=dinosaurMonster time=0.6 ease=backOut";
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).option = "dinosaur";
		items[2].x = 1382.6;
		items[2].y = 1205.4;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[3] as IZoraHurstonStoryLayout_paperLayer);
		(items[3] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotEnvironment.call(items[4] as IZoraHurstonStoryLayout_slotEnvironment);
		items[4].x = 0;
		items[4].y = 0;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"isPaperLayer":true});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[5] as IZoraHurstonStoryLayout_paperLayer);
		(items[5] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[5].x = 0;
		items[5].y = 0;
		items[5].width = 2048.00;
		items[5].height = 1536.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"from classroomMonsterStart id=classroomMonster time=0.6 ease=backOut","isButton":true,"option":"classroom"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomAnim.call(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim);
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).animation = "from classroomMonsterStart id=classroomMonster time=0.6 ease=backOut";
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).isButton = true;
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).option = "classroom";
		items[6].x = 1720.5;
		items[6].y = 892.8;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":false,"option":"classroom"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotClassroomTop.call(items[7] as IZoraHurstonStoryLayout_slotClassroomTop);
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).animation = "";
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).isButton = false;
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).option = "classroom";
		items[7].x = 1648.75;
		items[7].y = 1194.65;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch","isButton":true,"option":"playground"});
	}
	if (items[8]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim.call(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim);
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).animation = "squishStretch";
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).isButton = true;
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).option = "playground";
		items[8].x = 1720.65;
		items[8].y = 1111.2;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[9]) {
		ZoraHurstonStoryLayout_hurPlayground1.call(items[9] as IZoraHurstonStoryLayout_hurPlayground1);
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).animation = "";
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).isButton = true;
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).option = "playground";
		items[9].x = 1348.6;
		items[9].y = 1137.25;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"id=classroomMonsterStart","isButton":false,"option":"undefined"});
	}
	if (items[10]) {
		ZoraHurstonStoryLayout_hurOctopus12.call(items[10] as IZoraHurstonStoryLayout_hurOctopus12);
		(items[10] as IZoraHurstonStoryLayout_hurOctopus12).animation = "id=classroomMonsterStart";
		(items[10] as IZoraHurstonStoryLayout_hurOctopus12).isButton = false;
		(items[10] as IZoraHurstonStoryLayout_hurOctopus12).option = "undefined";
		items[10].x = 1730.1;
		items[10].y = 1170.75;
		if (items[10].scale) items[10].scale.x = 0.500;
		if (items[10].scale) items[10].scale.y = 0.500;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"id=kidzoneMonsterStart","isButton":false,"option":"undefined"});
	}
	if (items[11]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[11] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[11] as IZoraHurstonStoryLayout_hurOctopus11).animation = "id=kidzoneMonsterStart";
		(items[11] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[11] as IZoraHurstonStoryLayout_hurOctopus11).option = "undefined";
		items[11].x = 1464.85;
		items[11].y = 1270.65;
		if (items[11].scale) items[11].scale.x = 0.500;
		if (items[11].scale) items[11].scale.y = 0.500;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"id=dinosaurMonsterStart","isButton":false,"option":"undefined"});
	}
	if (items[12]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[12] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[12] as IZoraHurstonStoryLayout_hurOctopus11).animation = "id=dinosaurMonsterStart";
		(items[12] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[12] as IZoraHurstonStoryLayout_hurOctopus11).option = "undefined";
		items[12].x = 1391.65;
		items[12].y = 1313.35;
		if (items[12].scale) items[12].scale.x = 0.500;
		if (items[12].scale) items[12].scale.y = 0.500;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"maskOf":"classroomMonster"});
	}
	if (items[13]) {
		ZoraHurstonStoryLayout_desk_mask.call(items[13] as IZoraHurstonStoryLayout_desk_mask);
		(items[13] as IZoraHurstonStoryLayout_desk_mask).maskOf = "classroomMonster";
		items[13].x = 956.8;
		items[13].y = -70.35;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"maskOf":"kidzoneMonster"});
	}
	if (items[14]) {
		ZoraHurstonStoryLayout_playground_mask.call(items[14] as IZoraHurstonStoryLayout_playground_mask);
		(items[14] as IZoraHurstonStoryLayout_playground_mask).maskOf = "kidzoneMonster";
		items[14].x = 956.8;
		items[14].y = -70.35;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"classroom"});
	}
	if (items[15]) {
		ZoraHurstonStoryLayout_hurBSitdsurprised1.call(items[15] as IZoraHurstonStoryLayout_hurBSitdsurprised1);
		(items[15] as IZoraHurstonStoryLayout_hurBSitdsurprised1).animation = "squishStretch appear delay=0.2";
		(items[15] as IZoraHurstonStoryLayout_hurBSitdsurprised1).isButton = true;
		(items[15] as IZoraHurstonStoryLayout_hurBSitdsurprised1).option = "classroom";
		items[15].x = 559.8;
		items[15].y = 1121.15;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"playground"});
	}
	if (items[16]) {
		ZoraHurstonStoryLayout_hurBSitdsurprised1.call(items[16] as IZoraHurstonStoryLayout_hurBSitdsurprised1);
		(items[16] as IZoraHurstonStoryLayout_hurBSitdsurprised1).animation = "squishStretch appear delay=0.2";
		(items[16] as IZoraHurstonStoryLayout_hurBSitdsurprised1).isButton = true;
		(items[16] as IZoraHurstonStoryLayout_hurBSitdsurprised1).option = "playground";
		items[16].x = 560.55;
		items[16].y = 1120.35;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"kidzone"});
	}
	if (items[17]) {
		ZoraHurstonStoryLayout_hurBSitdsurprised1.call(items[17] as IZoraHurstonStoryLayout_hurBSitdsurprised1);
		(items[17] as IZoraHurstonStoryLayout_hurBSitdsurprised1).animation = "squishStretch appear delay=0.2";
		(items[17] as IZoraHurstonStoryLayout_hurBSitdsurprised1).isButton = true;
		(items[17] as IZoraHurstonStoryLayout_hurBSitdsurprised1).option = "kidzone";
		items[17].x = 559.85;
		items[17].y = 918.2;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"dinosaur"});
	}
	if (items[18]) {
		ZoraHurstonStoryLayout_hurBSitdsurprised1.call(items[18] as IZoraHurstonStoryLayout_hurBSitdsurprised1);
		(items[18] as IZoraHurstonStoryLayout_hurBSitdsurprised1).animation = "squishStretch appear delay=0.2";
		(items[18] as IZoraHurstonStoryLayout_hurBSitdsurprised1).isButton = true;
		(items[18] as IZoraHurstonStoryLayout_hurBSitdsurprised1).option = "dinosaur";
		items[18].x = 900.65;
		items[18].y = 924.1;
		if (items[18].onLayout) items[18].onLayout();
	}
	if (!items[19] && items.elementFactory) {
		items[19] = items.elementFactory(19,{"animation":"","isButton":true,"option":"classroom"});
	}
	if (items[19]) {
		ZoraHurstonStoryLayout_hurDinoBook1Anim.call(items[19] as IZoraHurstonStoryLayout_hurDinoBook1Anim);
		(items[19] as IZoraHurstonStoryLayout_hurDinoBook1Anim).animation = "";
		(items[19] as IZoraHurstonStoryLayout_hurDinoBook1Anim).isButton = true;
		(items[19] as IZoraHurstonStoryLayout_hurDinoBook1Anim).option = "classroom";
		items[19].x = 557.2;
		items[19].y = 1214.7;
		if (items[19].onLayout) items[19].onLayout();
	}
	if (!items[20] && items.elementFactory) {
		items[20] = items.elementFactory(20,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[20]) {
		ZoraHurstonStoryLayout_hurDinoBook1Anim.call(items[20] as IZoraHurstonStoryLayout_hurDinoBook1Anim);
		(items[20] as IZoraHurstonStoryLayout_hurDinoBook1Anim).animation = "";
		(items[20] as IZoraHurstonStoryLayout_hurDinoBook1Anim).isButton = true;
		(items[20] as IZoraHurstonStoryLayout_hurDinoBook1Anim).option = "playground";
		items[20].x = 564.35;
		items[20].y = 1212.85;
		if (items[20].onLayout) items[20].onLayout();
	}
	if (!items[21] && items.elementFactory) {
		items[21] = items.elementFactory(21,{"animation":"","isButton":true,"option":"kidzone"});
	}
	if (items[21]) {
		ZoraHurstonStoryLayout_hurDinoBook1Anim.call(items[21] as IZoraHurstonStoryLayout_hurDinoBook1Anim);
		(items[21] as IZoraHurstonStoryLayout_hurDinoBook1Anim).animation = "";
		(items[21] as IZoraHurstonStoryLayout_hurDinoBook1Anim).isButton = true;
		(items[21] as IZoraHurstonStoryLayout_hurDinoBook1Anim).option = "kidzone";
		items[21].x = 752.2;
		items[21].y = 1143.1;
		if (items[21].onLayout) items[21].onLayout();
	}
	if (!items[22] && items.elementFactory) {
		items[22] = items.elementFactory(22,{"animation":"","isButton":true,"option":"dinosaur"});
	}
	if (items[22]) {
		ZoraHurstonStoryLayout_hurDinoBook1Anim.call(items[22] as IZoraHurstonStoryLayout_hurDinoBook1Anim);
		(items[22] as IZoraHurstonStoryLayout_hurDinoBook1Anim).animation = "";
		(items[22] as IZoraHurstonStoryLayout_hurDinoBook1Anim).isButton = true;
		(items[22] as IZoraHurstonStoryLayout_hurDinoBook1Anim).option = "dinosaur";
		items[22].x = 901.2;
		items[22].y = 1016.6;
		if (items[22].onLayout) items[22].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterKidzoneAnim(this: IZoraHurstonStoryLayout_slotEnconterKidzoneAnim) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].scale) items[0].scale.x = 0.868;
		if (items[0].scale) items[0].scale.y = 0.868;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = -127.8;
		items[1].y = -851.95;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 10.5;
		items[2].y = 59.25;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = -42.05;
		items[3].y = -182.95;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurOctopus11(this: IZoraHurstonStoryLayout_hurOctopus11) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurChest1.call(items[0] as IZoraHurstonStoryLayout_hurChest1);
		items[0].x = -72;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurOctopus1.call(items[1] as IZoraHurstonStoryLayout_hurOctopus1);
		items[1].x = 55;
		items[1].y = -265;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurChest1(this: IZoraHurstonStoryLayout_hurChest1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurChest.call(items[0] as IZoraHurstonStoryLayout_hurChest);
		items[0].x = -278.5;
		items[0].y = -408;
		items[0].width = 557.00;
		items[0].height = 408.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurChest(this: IZoraHurstonStoryLayout_hurChest) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-chest.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurOctopus1(this: IZoraHurstonStoryLayout_hurOctopus1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus.call(items[0] as IZoraHurstonStoryLayout_hurOctopus);
		items[0].x = -295.5;
		items[0].y = -793;
		items[0].width = 591.00;
		items[0].height = 793.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurOctopus(this: IZoraHurstonStoryLayout_hurOctopus) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-octopus.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurMummy(this: IZoraHurstonStoryLayout_hurMummy) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurMummy1.call(items[0] as IZoraHurstonStoryLayout_hurMummy1);
		items[0].x = 120;
		items[0].y = 449;
		items[0].width = 240.00;
		items[0].height = 898.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurMummy1(this: IZoraHurstonStoryLayout_hurMummy1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-mummy.png", 0.500, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_hurMoose(this: IZoraHurstonStoryLayout_hurMoose) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurMoose1.call(items[0] as IZoraHurstonStoryLayout_hurMoose1);
		items[0].x = 0;
		items[0].y = -515.5;
		items[0].width = 789.00;
		items[0].height = 968.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurMoose1(this: IZoraHurstonStoryLayout_hurMoose1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-moose.png", 0.654, 0.468);
	return this;
}
function ZoraHurstonStoryLayout_hurKnight(this: IZoraHurstonStoryLayout_hurKnight) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurKnight1.call(items[0] as IZoraHurstonStoryLayout_hurKnight1);
		items[0].x = 0;
		items[0].y = -195;
		items[0].width = 339.00;
		items[0].height = 390.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurKnight1(this: IZoraHurstonStoryLayout_hurKnight1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-marshmallow.png", 0.500, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterDinosaurAnim(this: IZoraHurstonStoryLayout_slotEnconterDinosaurAnim) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = -118.05;
		items[1].y = -1082.7;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 67.05;
		items[2].y = -136.15;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = -19.55;
		items[3].y = -357.75;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnvironment(this: IZoraHurstonStoryLayout_slotEnvironment) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"classroom"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotClassroom1.call(items[0] as IZoraHurstonStoryLayout_slotClassroom1);
		(items[0] as IZoraHurstonStoryLayout_slotClassroom1).option = "classroom";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurPlayground.call(items[1] as IZoraHurstonStoryLayout_hurPlayground);
		(items[1] as IZoraHurstonStoryLayout_hurPlayground).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurPlayground).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurPlayground).option = "playground";
		items[1].x = 0;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"kidzone"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurKidzone.call(items[2] as IZoraHurstonStoryLayout_hurKidzone);
		(items[2] as IZoraHurstonStoryLayout_hurKidzone).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurKidzone).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_hurKidzone).option = "kidzone";
		items[2].x = 1083.3;
		items[2].y = 1148;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"static","isButton":false,"option":"dinosaur"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurDinosaur.call(items[3] as IZoraHurstonStoryLayout_hurDinosaur);
		(items[3] as IZoraHurstonStoryLayout_hurDinosaur).animation = "static";
		(items[3] as IZoraHurstonStoryLayout_hurDinosaur).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurDinosaur).option = "dinosaur";
		items[3].x = 1024.8;
		items[3].y = 1044.5;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotClassroom1(this: IZoraHurstonStoryLayout_slotClassroom1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotChalkboard.call(items[0] as IZoraHurstonStoryLayout_slotChalkboard);
		(items[0] as IZoraHurstonStoryLayout_slotChalkboard).animation = "";
		(items[0] as IZoraHurstonStoryLayout_slotChalkboard).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_slotChalkboard).option = "";
		items[0].x = 1024.7;
		items[0].y = 504.3;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurClassroomChair.call(items[1] as IZoraHurstonStoryLayout_hurClassroomChair);
		(items[1] as IZoraHurstonStoryLayout_hurClassroomChair).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurClassroomChair).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurClassroomChair).option = "";
		items[1].x = 1551.85;
		items[1].y = 519.7;
		items[1].width = 258.00;
		items[1].height = 245.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurPlayground(this: IZoraHurstonStoryLayout_hurPlayground) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBench1.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBench1).option = "";
		items[0].x = 328;
		items[0].y = 923;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurPlaygroundStructure1.call(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1);
		(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurPlaygroundStructure1).option = "";
		items[1].x = 1050;
		items[1].y = 1010;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEncounterClassroomAnim(this: IZoraHurstonStoryLayout_slotEncounterClassroomAnim) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus12.call(items[0] as IZoraHurstonStoryLayout_hurOctopus12);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[1] as IZoraHurstonStoryLayout_hurMoose);
		(items[1] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[1].x = -146.15;
		items[1].y = 137.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[2] as IZoraHurstonStoryLayout_hurKnight);
		(items[2] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[2].x = -164.2;
		items[2].y = -82.45;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[3] as IZoraHurstonStoryLayout_hurMummy);
		(items[3] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[3].x = -250.75;
		items[3].y = -779.4;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurOctopus12(this: IZoraHurstonStoryLayout_hurOctopus12) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus1.call(items[0] as IZoraHurstonStoryLayout_hurOctopus1);
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotClassroomTop(this: IZoraHurstonStoryLayout_slotClassroomTop) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotDesk.call(items[0] as IZoraHurstonStoryLayout_slotDesk);
		(items[0] as IZoraHurstonStoryLayout_slotDesk).animation = "";
		(items[0] as IZoraHurstonStoryLayout_slotDesk).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_slotDesk).option = "";
		items[0].x = -92.45;
		items[0].y = -386.8;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotPlant.call(items[1] as IZoraHurstonStoryLayout_slotPlant);
		(items[1] as IZoraHurstonStoryLayout_slotPlant).animation = "";
		(items[1] as IZoraHurstonStoryLayout_slotPlant).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_slotPlant).option = "";
		items[1].x = 286;
		items[1].y = -191.5;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim(this: IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].scale) items[0].scale.x = 0.868;
		if (items[0].scale) items[0].scale.y = 0.868;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = -110.95;
		items[1].y = -894.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = -57.9;
		items[2].y = 8.9;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = 1.15;
		items[3].y = 15.9;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_desk_mask(this: IZoraHurstonStoryLayout_desk_mask) {
	const maskPoints = this.maskPoints;
	maskPoints.push(1811.45,0.00,1816.50,1163.55,261.35,955.10,261.35,797.40,-244.75,795.90,-245.05,-3.65);
	return this;
}
function ZoraHurstonStoryLayout_desk_maskPoints(this: IZoraHurstonStoryLayout_desk_maskPoints) {
	return this;
}
function ZoraHurstonStoryLayout_playground_mask(this: IZoraHurstonStoryLayout_playground_mask) {
	const maskPoints = this.maskPoints;
	maskPoints.push(1811.45,0.00,1827.75,961.35,261.35,955.10,-252.70,942.35,-417.95,659.00,-422.65,-3.65);
	return this;
}
function ZoraHurstonStoryLayout_playground_maskPoints(this: IZoraHurstonStoryLayout_playground_maskPoints) {
	return this;
}
function ZoraHurstonStoryLayout_hurBSitdsurprised1(this: IZoraHurstonStoryLayout_hurBSitdsurprised1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSitdsurprised.call(items[0] as IZoraHurstonStoryLayout_hurBSitdsurprised);
		items[0].x = -166;
		items[0].y = -472;
		items[0].width = 332.00;
		items[0].height = 472.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSitdsurprised(this: IZoraHurstonStoryLayout_hurBSitdsurprised) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sitdsurprised.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurDinoBook1Anim(this: IZoraHurstonStoryLayout_hurDinoBook1Anim) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"from comics appear delay=0.4 time=0.2 ease=sineIn","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDinoBook.call(items[0] as IZoraHurstonStoryLayout_hurDinoBook);
		(items[0] as IZoraHurstonStoryLayout_hurDinoBook).animation = "from comics appear delay=0.4 time=0.2 ease=sineIn";
		(items[0] as IZoraHurstonStoryLayout_hurDinoBook).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurDinoBook).option = "";
		items[0].x = 0.5;
		items[0].y = -59;
		items[0].width = 265.00;
		items[0].height = 118.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"id=comics","isButton":false,"option":"undefined"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurDinoBook.call(items[1] as IZoraHurstonStoryLayout_hurDinoBook);
		(items[1] as IZoraHurstonStoryLayout_hurDinoBook).animation = "id=comics";
		(items[1] as IZoraHurstonStoryLayout_hurDinoBook).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurDinoBook).option = "undefined";
		items[1].x = -3.4;
		items[1].y = -268.3;
		items[1].rotation = -3.1193;
		items[1].width = 171.59;
		items[1].height = 76.40;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDinoBook(this: IZoraHurstonStoryLayout_hurDinoBook) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-dino-book.png", 0.502, 0.500);
	return this;
}
export function ZoraHurstonStoryLayout_scene3Reaction(this: IZoraHurstonStoryLayout_scene3Reaction) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotEncountersBack.call(items[0] as IZoraHurstonStoryLayout_slotEncountersBack);
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[1] as IZoraHurstonStoryLayout_paperLayer);
		(items[1] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnvironment.call(items[2] as IZoraHurstonStoryLayout_slotEnvironment);
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[3] as IZoraHurstonStoryLayout_paperLayer);
		(items[3] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotEncountersFront.call(items[4] as IZoraHurstonStoryLayout_slotEncountersFront);
		items[4].x = 0;
		items[4].y = 0;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_hurPlayground1.call(items[5] as IZoraHurstonStoryLayout_hurPlayground1);
		(items[5] as IZoraHurstonStoryLayout_hurPlayground1).animation = "";
		(items[5] as IZoraHurstonStoryLayout_hurPlayground1).isButton = true;
		(items[5] as IZoraHurstonStoryLayout_hurPlayground1).option = "playground";
		items[5].x = 1348.6;
		items[5].y = 1137.25;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"","isButton":true,"option":"classroom"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_hurDinoBook1.call(items[6] as IZoraHurstonStoryLayout_hurDinoBook1);
		(items[6] as IZoraHurstonStoryLayout_hurDinoBook1).animation = "";
		(items[6] as IZoraHurstonStoryLayout_hurDinoBook1).isButton = true;
		(items[6] as IZoraHurstonStoryLayout_hurDinoBook1).option = "classroom";
		items[6].x = 814.5;
		items[6].y = 1121;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_hurDinoBook1.call(items[7] as IZoraHurstonStoryLayout_hurDinoBook1);
		(items[7] as IZoraHurstonStoryLayout_hurDinoBook1).animation = "";
		(items[7] as IZoraHurstonStoryLayout_hurDinoBook1).isButton = true;
		(items[7] as IZoraHurstonStoryLayout_hurDinoBook1).option = "playground";
		items[7].x = 812.7;
		items[7].y = 1121;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"","isButton":true,"option":"kidzone"});
	}
	if (items[8]) {
		ZoraHurstonStoryLayout_hurDinoBook1.call(items[8] as IZoraHurstonStoryLayout_hurDinoBook1);
		(items[8] as IZoraHurstonStoryLayout_hurDinoBook1).animation = "";
		(items[8] as IZoraHurstonStoryLayout_hurDinoBook1).isButton = true;
		(items[8] as IZoraHurstonStoryLayout_hurDinoBook1).option = "kidzone";
		items[8].x = 752.2;
		items[8].y = 1143.1;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":true,"option":"dinosaur"});
	}
	if (items[9]) {
		ZoraHurstonStoryLayout_hurDinoBook1.call(items[9] as IZoraHurstonStoryLayout_hurDinoBook1);
		(items[9] as IZoraHurstonStoryLayout_hurDinoBook1).animation = "";
		(items[9] as IZoraHurstonStoryLayout_hurDinoBook1).isButton = true;
		(items[9] as IZoraHurstonStoryLayout_hurDinoBook1).option = "dinosaur";
		items[9].x = 1154.4;
		items[9].y = 925.55;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"squishStretch","isButton":true,"option":"classroom"});
	}
	if (items[10]) {
		ZoraHurstonStoryLayout_slotBradReaction.call(items[10] as IZoraHurstonStoryLayout_slotBradReaction);
		(items[10] as IZoraHurstonStoryLayout_slotBradReaction).animation = "squishStretch";
		(items[10] as IZoraHurstonStoryLayout_slotBradReaction).isButton = true;
		(items[10] as IZoraHurstonStoryLayout_slotBradReaction).option = "classroom";
		items[10].x = 586.3;
		items[10].y = 1096.7;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"squishStretch","isButton":true,"option":"playground"});
	}
	if (items[11]) {
		ZoraHurstonStoryLayout_slotBradReaction.call(items[11] as IZoraHurstonStoryLayout_slotBradReaction);
		(items[11] as IZoraHurstonStoryLayout_slotBradReaction).animation = "squishStretch";
		(items[11] as IZoraHurstonStoryLayout_slotBradReaction).isButton = true;
		(items[11] as IZoraHurstonStoryLayout_slotBradReaction).option = "playground";
		items[11].x = 585.25;
		items[11].y = 1096.05;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"squishStretch","isButton":true,"option":"kidzone"});
	}
	if (items[12]) {
		ZoraHurstonStoryLayout_slotBradReaction.call(items[12] as IZoraHurstonStoryLayout_slotBradReaction);
		(items[12] as IZoraHurstonStoryLayout_slotBradReaction).animation = "squishStretch";
		(items[12] as IZoraHurstonStoryLayout_slotBradReaction).isButton = true;
		(items[12] as IZoraHurstonStoryLayout_slotBradReaction).option = "kidzone";
		items[12].x = 586.35;
		items[12].y = 1097;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"squishStretch","isButton":true,"option":"dinosaur"});
	}
	if (items[13]) {
		ZoraHurstonStoryLayout_slotBradReaction.call(items[13] as IZoraHurstonStoryLayout_slotBradReaction);
		(items[13] as IZoraHurstonStoryLayout_slotBradReaction).animation = "squishStretch";
		(items[13] as IZoraHurstonStoryLayout_slotBradReaction).isButton = true;
		(items[13] as IZoraHurstonStoryLayout_slotBradReaction).option = "dinosaur";
		items[13].x = 916.2;
		items[13].y = 914.75;
		if (items[13].onLayout) items[13].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEncountersBack(this: IZoraHurstonStoryLayout_slotEncountersBack) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[0].x = 440;
		items[0].y = 133;
		items[0].width = 1391.90;
		items[0].height = 813.30;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"id=kidzoneMonster","isButton":true,"option":"kidzone"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotEnconterKidzone.call(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzone);
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzone).animation = "id=kidzoneMonster";
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzone).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzone).option = "kidzone";
		items[1].x = 0;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"dinosaur"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaur.call(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaur);
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaur).animation = "";
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaur).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaur).option = "dinosaur";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"maskOf":"kidzoneMonster"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_playground_mask.call(items[3] as IZoraHurstonStoryLayout_playground_mask);
		(items[3] as IZoraHurstonStoryLayout_playground_mask).maskOf = "kidzoneMonster";
		items[3].x = 956.8;
		items[3].y = -70.35;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterKidzone(this: IZoraHurstonStoryLayout_slotEnconterKidzone) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 1440.6;
		items[0].y = 951.85;
		if (items[0].scale) items[0].scale.x = 0.868;
		if (items[0].scale) items[0].scale.y = 0.868;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = 1312.8;
		items[1].y = 99.9;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 1451.1;
		items[2].y = 1011.1;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = 1398.55;
		items[3].y = 768.9;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterDinosaur(this: IZoraHurstonStoryLayout_slotEnconterDinosaur) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 1382.6;
		items[0].y = 1205.4;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = 1264.55;
		items[1].y = 122.7;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 1449.65;
		items[2].y = 1069.25;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = 1363.05;
		items[3].y = 847.65;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEncountersFront(this: IZoraHurstonStoryLayout_slotEncountersFront) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"id=classroomMonster","isButton":true,"option":"classroom"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotEncounterClassroom.call(items[0] as IZoraHurstonStoryLayout_slotEncounterClassroom);
		(items[0] as IZoraHurstonStoryLayout_slotEncounterClassroom).animation = "id=classroomMonster";
		(items[0] as IZoraHurstonStoryLayout_slotEncounterClassroom).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_slotEncounterClassroom).option = "classroom";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"classroom"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotClassroomTop.call(items[1] as IZoraHurstonStoryLayout_slotClassroomTop);
		(items[1] as IZoraHurstonStoryLayout_slotClassroomTop).animation = "";
		(items[1] as IZoraHurstonStoryLayout_slotClassroomTop).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_slotClassroomTop).option = "classroom";
		items[1].x = 1648.75;
		items[1].y = 1194.65;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnconterPlayground.call(items[2] as IZoraHurstonStoryLayout_slotEnconterPlayground);
		(items[2] as IZoraHurstonStoryLayout_slotEnconterPlayground).animation = "";
		(items[2] as IZoraHurstonStoryLayout_slotEnconterPlayground).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotEnconterPlayground).option = "playground";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"maskOf":"classroomMonster"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_desk_mask.call(items[3] as IZoraHurstonStoryLayout_desk_mask);
		(items[3] as IZoraHurstonStoryLayout_desk_mask).maskOf = "classroomMonster";
		items[3].x = 956.8;
		items[3].y = -70.35;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEncounterClassroom(this: IZoraHurstonStoryLayout_slotEncounterClassroom) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus12.call(items[0] as IZoraHurstonStoryLayout_hurOctopus12);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).option = "octopus";
		items[0].x = 1720.5;
		items[0].y = 892.8;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[1] as IZoraHurstonStoryLayout_hurMoose);
		(items[1] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[1].x = 1575.05;
		items[1].y = 1032.15;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[2] as IZoraHurstonStoryLayout_hurKnight);
		(items[2] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[2].x = 1555.95;
		items[2].y = 811.5;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[3] as IZoraHurstonStoryLayout_hurMummy);
		(items[3] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[3].x = 1469.5;
		items[3].y = 112.9;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterPlayground(this: IZoraHurstonStoryLayout_slotEnconterPlayground) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 1720.75;
		items[0].y = 1111.2;
		if (items[0].scale) items[0].scale.x = 0.868;
		if (items[0].scale) items[0].scale.y = 0.868;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = 1609.8;
		items[1].y = 217.55;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 1663.85;
		items[2].y = 1119.65;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = 1721.65;
		items[3].y = 1126.2;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDinoBook1(this: IZoraHurstonStoryLayout_hurDinoBook1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDinoBook.call(items[0] as IZoraHurstonStoryLayout_hurDinoBook);
		(items[0] as IZoraHurstonStoryLayout_hurDinoBook).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurDinoBook).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurDinoBook).option = "";
		items[0].x = 0.5;
		items[0].y = -59;
		items[0].width = 265.00;
		items[0].height = 118.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotBradReaction(this: IZoraHurstonStoryLayout_slotBradReaction) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"sad"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSad1.call(items[0] as IZoraHurstonStoryLayout_hurBSad1);
		(items[0] as IZoraHurstonStoryLayout_hurBSad1).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurBSad1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurBSad1).option = "sad";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"nervous"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurBNervous1.call(items[1] as IZoraHurstonStoryLayout_hurBNervous1);
		(items[1] as IZoraHurstonStoryLayout_hurBNervous1).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurBNervous1).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurBNervous1).option = "nervous";
		items[1].x = 0;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"brave"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurBBrave1.call(items[2] as IZoraHurstonStoryLayout_hurBBrave1);
		(items[2] as IZoraHurstonStoryLayout_hurBBrave1).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurBBrave1).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurBBrave1).option = "brave";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSad1(this: IZoraHurstonStoryLayout_hurBSad1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSad.call(items[0] as IZoraHurstonStoryLayout_hurBSad);
		items[0].x = -163;
		items[0].y = -507;
		items[0].width = 326.00;
		items[0].height = 507.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSad(this: IZoraHurstonStoryLayout_hurBSad) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sad.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurBNervous1(this: IZoraHurstonStoryLayout_hurBNervous1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBNervous.call(items[0] as IZoraHurstonStoryLayout_hurBNervous);
		items[0].x = -165.5;
		items[0].y = -499;
		items[0].width = 331.00;
		items[0].height = 499.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBNervous(this: IZoraHurstonStoryLayout_hurBNervous) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-nervous.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurBBrave1(this: IZoraHurstonStoryLayout_hurBBrave1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBBrave.call(items[0] as IZoraHurstonStoryLayout_hurBBrave);
		items[0].x = -166;
		items[0].y = -525;
		items[0].width = 332.00;
		items[0].height = 525.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBBrave(this: IZoraHurstonStoryLayout_hurBBrave) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-brave.png", 0.000, 0.000);
	return this;
}
export function ZoraHurstonStoryLayout_scene4Help(this: IZoraHurstonStoryLayout_scene4Help) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[0].x = 440;
		items[0].y = 133;
		items[0].width = 1391.90;
		items[0].height = 813.30;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"excited id=kidzoneMonster delay=0.4","isButton":true,"option":"kidzone"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneAnim.call(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim);
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).animation = "excited id=kidzoneMonster delay=0.4";
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).option = "kidzone";
		items[1].x = 1440.5;
		items[1].y = 952.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"excited delay=0.4","isButton":true,"option":"dinosaur"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurAnim.call(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim);
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).animation = "excited delay=0.4";
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).option = "dinosaur";
		items[2].x = 1382.6;
		items[2].y = 1205.4;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[3] as IZoraHurstonStoryLayout_paperLayer);
		(items[3] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotEnvironment.call(items[4] as IZoraHurstonStoryLayout_slotEnvironment);
		items[4].x = 0;
		items[4].y = 0;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"isPaperLayer":true});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[5] as IZoraHurstonStoryLayout_paperLayer);
		(items[5] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[5].x = 0;
		items[5].y = 0;
		items[5].width = 2048.00;
		items[5].height = 1536.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"excited id=classroomMonster delay=0.4","isButton":true,"option":"classroom"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomAnim.call(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim);
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).animation = "excited id=classroomMonster delay=0.4";
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).isButton = true;
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).option = "classroom";
		items[6].x = 1720.5;
		items[6].y = 892.8;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":false,"option":"classroom"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotClassroomTop.call(items[7] as IZoraHurstonStoryLayout_slotClassroomTop);
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).animation = "";
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).isButton = false;
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).option = "classroom";
		items[7].x = 1648.75;
		items[7].y = 1194.65;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"excited delay=0.4","isButton":true,"option":"playground"});
	}
	if (items[8]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim.call(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim);
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).animation = "excited delay=0.4";
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).isButton = true;
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).option = "playground";
		items[8].x = 1720.65;
		items[8].y = 1111.2;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[9]) {
		ZoraHurstonStoryLayout_hurPlayground1.call(items[9] as IZoraHurstonStoryLayout_hurPlayground1);
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).animation = "";
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).isButton = true;
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).option = "playground";
		items[9].x = 1348.6;
		items[9].y = 1137.25;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"maskOf":"classroomMonster"});
	}
	if (items[10]) {
		ZoraHurstonStoryLayout_desk_mask.call(items[10] as IZoraHurstonStoryLayout_desk_mask);
		(items[10] as IZoraHurstonStoryLayout_desk_mask).maskOf = "classroomMonster";
		items[10].x = 956.8;
		items[10].y = -70.35;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"maskOf":"kidzoneMonster"});
	}
	if (items[11]) {
		ZoraHurstonStoryLayout_playground_mask.call(items[11] as IZoraHurstonStoryLayout_playground_mask);
		(items[11] as IZoraHurstonStoryLayout_playground_mask).maskOf = "kidzoneMonster";
		items[11].x = 956.8;
		items[11].y = -70.35;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"isPaperLayer":true});
	}
	if (items[12]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[12] as IZoraHurstonStoryLayout_paperLayer);
		(items[12] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[12].x = 0;
		items[12].y = 0;
		items[12].width = 2048.00;
		items[12].height = 1536.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"squishStretch","isButton":true,"option":"classroom"});
	}
	if (items[13]) {
		ZoraHurstonStoryLayout_slotBradShare.call(items[13] as IZoraHurstonStoryLayout_slotBradShare);
		(items[13] as IZoraHurstonStoryLayout_slotBradShare).animation = "squishStretch";
		(items[13] as IZoraHurstonStoryLayout_slotBradShare).isButton = true;
		(items[13] as IZoraHurstonStoryLayout_slotBradShare).option = "classroom";
		items[13].x = 855.4;
		items[13].y = 1095.45;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"squishStretch","isButton":true,"option":"playground"});
	}
	if (items[14]) {
		ZoraHurstonStoryLayout_slotBradShare.call(items[14] as IZoraHurstonStoryLayout_slotBradShare);
		(items[14] as IZoraHurstonStoryLayout_slotBradShare).animation = "squishStretch";
		(items[14] as IZoraHurstonStoryLayout_slotBradShare).isButton = true;
		(items[14] as IZoraHurstonStoryLayout_slotBradShare).option = "playground";
		items[14].x = 560.6;
		items[14].y = 1100.3;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"squishStretch","isButton":true,"option":"kidzone"});
	}
	if (items[15]) {
		ZoraHurstonStoryLayout_slotBradShare.call(items[15] as IZoraHurstonStoryLayout_slotBradShare);
		(items[15] as IZoraHurstonStoryLayout_slotBradShare).animation = "squishStretch";
		(items[15] as IZoraHurstonStoryLayout_slotBradShare).isButton = true;
		(items[15] as IZoraHurstonStoryLayout_slotBradShare).option = "kidzone";
		items[15].x = 569.45;
		items[15].y = 1097;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"squishStretch","isButton":true,"option":"dinosaur"});
	}
	if (items[16]) {
		ZoraHurstonStoryLayout_slotBradShare.call(items[16] as IZoraHurstonStoryLayout_slotBradShare);
		(items[16] as IZoraHurstonStoryLayout_slotBradShare).animation = "squishStretch";
		(items[16] as IZoraHurstonStoryLayout_slotBradShare).isButton = true;
		(items[16] as IZoraHurstonStoryLayout_slotBradShare).option = "dinosaur";
		items[16].x = 900.9;
		items[16].y = 913.9;
		if (items[16].onLayout) items[16].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotBradShare(this: IZoraHurstonStoryLayout_slotBradShare) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBShare1.call(items[0] as IZoraHurstonStoryLayout_hurBShare1);
		(items[0] as IZoraHurstonStoryLayout_hurBShare1).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurBShare1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurBShare1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"bikeman"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurStoryBikeman1.call(items[1] as IZoraHurstonStoryLayout_hurStoryBikeman1);
		(items[1] as IZoraHurstonStoryLayout_hurStoryBikeman1).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurStoryBikeman1).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurStoryBikeman1).option = "bikeman";
		items[1].x = 227.35;
		items[1].y = -248.25;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"cape"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurStoryCape1.call(items[2] as IZoraHurstonStoryLayout_hurStoryCape1);
		(items[2] as IZoraHurstonStoryLayout_hurStoryCape1).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurStoryCape1).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurStoryCape1).option = "cape";
		items[2].x = 230.05;
		items[2].y = -246.55;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"agent"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurStoryAgentchaos1.call(items[3] as IZoraHurstonStoryLayout_hurStoryAgentchaos1);
		(items[3] as IZoraHurstonStoryLayout_hurStoryAgentchaos1).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurStoryAgentchaos1).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurStoryAgentchaos1).option = "agent";
		items[3].x = 230.45;
		items[3].y = -247.8;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBShare1(this: IZoraHurstonStoryLayout_hurBShare1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBShare.call(items[0] as IZoraHurstonStoryLayout_hurBShare);
		items[0].x = -166;
		items[0].y = -528;
		items[0].width = 332.00;
		items[0].height = 528.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBShare(this: IZoraHurstonStoryLayout_hurBShare) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-share.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurStoryBikeman1(this: IZoraHurstonStoryLayout_hurStoryBikeman1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurStoryBikeman.call(items[0] as IZoraHurstonStoryLayout_hurStoryBikeman);
		items[0].x = -109;
		items[0].y = -131;
		items[0].width = 218.00;
		items[0].height = 262.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurStoryBikeman(this: IZoraHurstonStoryLayout_hurStoryBikeman) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-story-bikeman.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurStoryCape1(this: IZoraHurstonStoryLayout_hurStoryCape1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurStoryCape.call(items[0] as IZoraHurstonStoryLayout_hurStoryCape);
		items[0].x = -112;
		items[0].y = -132.5;
		items[0].width = 224.00;
		items[0].height = 265.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurStoryCape(this: IZoraHurstonStoryLayout_hurStoryCape) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-story-cape.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurStoryAgentchaos1(this: IZoraHurstonStoryLayout_hurStoryAgentchaos1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurStoryAgentchaos.call(items[0] as IZoraHurstonStoryLayout_hurStoryAgentchaos);
		items[0].x = -112;
		items[0].y = -132.5;
		items[0].width = 224.00;
		items[0].height = 265.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurStoryAgentchaos(this: IZoraHurstonStoryLayout_hurStoryAgentchaos) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-story-agentchaos.png", 0.000, 0.000);
	return this;
}
export function ZoraHurstonStoryLayout_scene5Result(this: IZoraHurstonStoryLayout_scene5Result) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[0].x = 440;
		items[0].y = 133;
		items[0].width = 1391.90;
		items[0].height = 813.30;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"id=kidzoneMonster","isButton":false,"option":"kidzone"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneSpeech.call(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech);
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech).animation = "id=kidzoneMonster";
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech).option = "kidzone";
		items[1].x = 1440.5;
		items[1].y = 952.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"dinosaur"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurSpeech.call(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech);
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech).animation = "";
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech).option = "dinosaur";
		items[2].x = 1382.6;
		items[2].y = 1205.4;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[3] as IZoraHurstonStoryLayout_paperLayer);
		(items[3] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotEnvironment.call(items[4] as IZoraHurstonStoryLayout_slotEnvironment);
		items[4].x = 0;
		items[4].y = 0;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"isPaperLayer":true});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[5] as IZoraHurstonStoryLayout_paperLayer);
		(items[5] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[5].x = 0;
		items[5].y = 0;
		items[5].width = 2048.00;
		items[5].height = 1536.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"id=classroomMonster","isButton":false,"option":"classroom"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomSpeech.call(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomSpeech);
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomSpeech).animation = "id=classroomMonster";
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomSpeech).isButton = false;
		(items[6] as IZoraHurstonStoryLayout_slotEncounterClassroomSpeech).option = "classroom";
		items[6].x = 1720.5;
		items[6].y = 892.8;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":false,"option":"classroom"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotClassroomTop.call(items[7] as IZoraHurstonStoryLayout_slotClassroomTop);
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).animation = "";
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).isButton = false;
		(items[7] as IZoraHurstonStoryLayout_slotClassroomTop).option = "classroom";
		items[7].x = 1648.75;
		items[7].y = 1194.65;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[8]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech.call(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech);
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech).animation = "";
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech).isButton = false;
		(items[8] as IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech).option = "playground";
		items[8].x = 1720.65;
		items[8].y = 1111.2;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[9]) {
		ZoraHurstonStoryLayout_hurPlayground1.call(items[9] as IZoraHurstonStoryLayout_hurPlayground1);
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).animation = "";
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).isButton = true;
		(items[9] as IZoraHurstonStoryLayout_hurPlayground1).option = "playground";
		items[9].x = 1348.6;
		items[9].y = 1137.25;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":false,"option":"dinosaur"});
	}
	if (items[10]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurBubble.call(items[10] as IZoraHurstonStoryLayout_slotEnconterDinosaurBubble);
		(items[10] as IZoraHurstonStoryLayout_slotEnconterDinosaurBubble).animation = "";
		(items[10] as IZoraHurstonStoryLayout_slotEnconterDinosaurBubble).isButton = false;
		(items[10] as IZoraHurstonStoryLayout_slotEnconterDinosaurBubble).option = "dinosaur";
		items[10].x = 1382.6;
		items[10].y = 1205.4;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"maskOf":"classroomMonster"});
	}
	if (items[11]) {
		ZoraHurstonStoryLayout_desk_mask.call(items[11] as IZoraHurstonStoryLayout_desk_mask);
		(items[11] as IZoraHurstonStoryLayout_desk_mask).maskOf = "classroomMonster";
		items[11].x = 956.8;
		items[11].y = -70.35;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"maskOf":"kidzoneMonster"});
	}
	if (items[12]) {
		ZoraHurstonStoryLayout_playground_mask.call(items[12] as IZoraHurstonStoryLayout_playground_mask);
		(items[12] as IZoraHurstonStoryLayout_playground_mask).maskOf = "kidzoneMonster";
		items[12].x = 956.8;
		items[12].y = -70.35;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"isPaperLayer":true});
	}
	if (items[13]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[13] as IZoraHurstonStoryLayout_paperLayer);
		(items[13] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[13].x = 0;
		items[13].y = 0;
		items[13].width = 2048.00;
		items[13].height = 1536.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"classroom"});
	}
	if (items[14]) {
		ZoraHurstonStoryLayout_slotBradEat.call(items[14] as IZoraHurstonStoryLayout_slotBradEat);
		(items[14] as IZoraHurstonStoryLayout_slotBradEat).animation = "squishStretch appear delay=0.2";
		(items[14] as IZoraHurstonStoryLayout_slotBradEat).isButton = true;
		(items[14] as IZoraHurstonStoryLayout_slotBradEat).option = "classroom";
		items[14].x = 855.4;
		items[14].y = 1095.45;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"playground"});
	}
	if (items[15]) {
		ZoraHurstonStoryLayout_slotBradEat.call(items[15] as IZoraHurstonStoryLayout_slotBradEat);
		(items[15] as IZoraHurstonStoryLayout_slotBradEat).animation = "squishStretch appear delay=0.2";
		(items[15] as IZoraHurstonStoryLayout_slotBradEat).isButton = true;
		(items[15] as IZoraHurstonStoryLayout_slotBradEat).option = "playground";
		items[15].x = 560.6;
		items[15].y = 1100.3;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"kidzone"});
	}
	if (items[16]) {
		ZoraHurstonStoryLayout_slotBradEat.call(items[16] as IZoraHurstonStoryLayout_slotBradEat);
		(items[16] as IZoraHurstonStoryLayout_slotBradEat).animation = "squishStretch appear delay=0.2";
		(items[16] as IZoraHurstonStoryLayout_slotBradEat).isButton = true;
		(items[16] as IZoraHurstonStoryLayout_slotBradEat).option = "kidzone";
		items[16].x = 569.45;
		items[16].y = 1097;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"dinosaur"});
	}
	if (items[17]) {
		ZoraHurstonStoryLayout_slotBradEat.call(items[17] as IZoraHurstonStoryLayout_slotBradEat);
		(items[17] as IZoraHurstonStoryLayout_slotBradEat).animation = "squishStretch appear delay=0.2";
		(items[17] as IZoraHurstonStoryLayout_slotBradEat).isButton = true;
		(items[17] as IZoraHurstonStoryLayout_slotBradEat).option = "dinosaur";
		items[17].x = 761.7;
		items[17].y = 913.9;
		if (items[17].onLayout) items[17].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterKidzoneSpeech(this: IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].scale) items[0].scale.x = 0.868;
		if (items[0].scale) items[0].scale.y = 0.868;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = -127.8;
		items[1].y = -851.95;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 10.5;
		items[2].y = 59.25;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = true;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = -42.05;
		items[3].y = -182.95;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"octopus"});
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "octopus";
		items[4].x = -40.9;
		items[4].y = -648.85;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"mummy"});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "mummy";
		items[5].x = -135.6;
		items[5].y = -653.9;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"moose"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "moose";
		items[6].x = -242.15;
		items[6].y = -608.45;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"marshmallow"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "marshmallow";
		items[7].x = -58.4;
		items[7].y = -588.15;
		if (items[7].onLayout) items[7].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotThoughtBubble(this: IZoraHurstonStoryLayout_slotThoughtBubble) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurThoughtBubble.call(items[0] as IZoraHurstonStoryLayout_hurThoughtBubble);
		items[0].x = -475;
		items[0].y = -339;
		items[0].width = 475.00;
		items[0].height = 339.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"happy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurEmojiHappy.call(items[1] as IZoraHurstonStoryLayout_hurEmojiHappy);
		(items[1] as IZoraHurstonStoryLayout_hurEmojiHappy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurEmojiHappy).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurEmojiHappy).option = "happy";
		items[1].x = -349.85;
		items[1].y = -269.8;
		items[1].width = 207.00;
		items[1].height = 197.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"silly"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurEmojiSilly.call(items[2] as IZoraHurstonStoryLayout_hurEmojiSilly);
		(items[2] as IZoraHurstonStoryLayout_hurEmojiSilly).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurEmojiSilly).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurEmojiSilly).option = "silly";
		items[2].x = -349.85;
		items[2].y = -269.8;
		items[2].width = 206.00;
		items[2].height = 197.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"hungry"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurEmojiHungry.call(items[3] as IZoraHurstonStoryLayout_hurEmojiHungry);
		(items[3] as IZoraHurstonStoryLayout_hurEmojiHungry).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurEmojiHungry).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurEmojiHungry).option = "hungry";
		items[3].x = -331.7;
		items[3].y = -283.95;
		items[3].width = 164.00;
		items[3].height = 215.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurThoughtBubble(this: IZoraHurstonStoryLayout_hurThoughtBubble) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-thought-bubble.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurEmojiHappy(this: IZoraHurstonStoryLayout_hurEmojiHappy) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-emoji-happy.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurEmojiSilly(this: IZoraHurstonStoryLayout_hurEmojiSilly) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-emoji-silly.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_hurEmojiHungry(this: IZoraHurstonStoryLayout_hurEmojiHungry) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-emoji-hungry.png", 0.000, 0.000);
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterDinosaurSpeech(this: IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = -118.05;
		items[1].y = -1082.7;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = 67.05;
		items[2].y = -136.15;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = true;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = -19.55;
		items[3].y = -357.75;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEncounterClassroomSpeech(this: IZoraHurstonStoryLayout_slotEncounterClassroomSpeech) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus12.call(items[0] as IZoraHurstonStoryLayout_hurOctopus12);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus12).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"moose"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[1] as IZoraHurstonStoryLayout_hurMoose);
		(items[1] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMoose).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[1].x = -146.15;
		items[1].y = 137.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"marshmallow"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[2] as IZoraHurstonStoryLayout_hurKnight);
		(items[2] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurKnight).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[2].x = -164.2;
		items[2].y = -82.45;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"mummy"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[3] as IZoraHurstonStoryLayout_hurMummy);
		(items[3] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurMummy).isButton = true;
		(items[3] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[3].x = -250.75;
		items[3].y = -779.4;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"octopus"});
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "octopus";
		items[4].x = -35.9;
		items[4].y = -528.95;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"moose"});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "moose";
		items[5].x = -425.4;
		items[5].y = -532.75;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"marshmallow"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "marshmallow";
		items[6].x = -181.95;
		items[6].y = -491.5;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"mummy"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "mummy";
		items[7].x = -250.75;
		items[7].y = -591.45;
		if (items[7].onLayout) items[7].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech(this: IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurOctopus11.call(items[0] as IZoraHurstonStoryLayout_hurOctopus11);
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_hurOctopus11).option = "octopus";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].scale) items[0].scale.x = 0.868;
		if (items[0].scale) items[0].scale.y = 0.868;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurMummy.call(items[1] as IZoraHurstonStoryLayout_hurMummy);
		(items[1] as IZoraHurstonStoryLayout_hurMummy).animation = "";
		(items[1] as IZoraHurstonStoryLayout_hurMummy).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_hurMummy).option = "mummy";
		items[1].x = -110.95;
		items[1].y = -894.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurMoose.call(items[2] as IZoraHurstonStoryLayout_hurMoose);
		(items[2] as IZoraHurstonStoryLayout_hurMoose).animation = "";
		(items[2] as IZoraHurstonStoryLayout_hurMoose).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_hurMoose).option = "moose";
		items[2].x = -57.9;
		items[2].y = 8.9;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurKnight.call(items[3] as IZoraHurstonStoryLayout_hurKnight);
		(items[3] as IZoraHurstonStoryLayout_hurKnight).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurKnight).isButton = true;
		(items[3] as IZoraHurstonStoryLayout_hurKnight).option = "marshmallow";
		items[3].x = 1.15;
		items[3].y = 15.9;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"octopus"});
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[4] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "octopus";
		items[4].x = 14;
		items[4].y = -690.3;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"mummy"});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[5] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "mummy";
		items[5].x = -56.6;
		items[5].y = -759.4;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"moose"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[6] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "moose";
		items[6].x = -339.45;
		items[6].y = -695.1;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"marshmallow"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[7] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "marshmallow";
		items[7].x = -37.9;
		items[7].y = -391.55;
		if (items[7].onLayout) items[7].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotEnconterDinosaurBubble(this: IZoraHurstonStoryLayout_slotEnconterDinosaurBubble) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"octopus"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[0] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[0] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[0] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[0] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "octopus";
		items[0].x = 21.7;
		items[0].y = -824.75;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"mummy"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[1] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[1] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[1] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "mummy";
		items[1].x = -118.05;
		items[1].y = -901.55;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"moose"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[2] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[2] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[2] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "moose";
		items[2].x = -189.65;
		items[2].y = -848.75;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"scaleUp ease=backOut time=0.4","isButton":true,"option":"marshmallow"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_slotThoughtBubble.call(items[3] as IZoraHurstonStoryLayout_slotThoughtBubble);
		(items[3] as IZoraHurstonStoryLayout_slotThoughtBubble).animation = "scaleUp ease=backOut time=0.4";
		(items[3] as IZoraHurstonStoryLayout_slotThoughtBubble).isButton = true;
		(items[3] as IZoraHurstonStoryLayout_slotThoughtBubble).option = "marshmallow";
		items[3].x = -45.55;
		items[3].y = -771.9;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_slotBradEat(this: IZoraHurstonStoryLayout_slotBradEat) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSnacking1.call(items[0] as IZoraHurstonStoryLayout_hurBSnacking1);
		items[0].x = 13;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSnacking1(this: IZoraHurstonStoryLayout_hurBSnacking1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSnacking.call(items[0] as IZoraHurstonStoryLayout_hurBSnacking);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 323.00;
		items[0].height = 529.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSnacking(this: IZoraHurstonStoryLayout_hurBSnacking) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur_b-amazed.png", 0.502, 1.000);
	return this;
}
export function ZoraHurstonStoryLayout_scene6End(this: IZoraHurstonStoryLayout_scene6End) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[0].x = 440;
		items[0].y = 133;
		items[0].width = 1391.90;
		items[0].height = 813.30;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"jump delay=0.3 id=kidzoneMonster","isButton":true,"option":"kidzone jam"});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneAnim.call(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim);
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).animation = "jump delay=0.3 id=kidzoneMonster";
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).isButton = true;
		(items[1] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).option = "kidzone jam";
		items[1].x = 1440.5;
		items[1].y = 952.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"jump delay=0.3","isButton":true,"option":"dinosaur jam"});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurAnim.call(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim);
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).animation = "jump delay=0.3";
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).isButton = true;
		(items[2] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).option = "dinosaur jam";
		items[2].x = 1382.6;
		items[2].y = 1205.4;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[3]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[3] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[3] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[3] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[3] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[3].x = 440;
		items[3].y = 133;
		items[3].width = 1391.90;
		items[3].height = 813.30;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"squishStretch id=kidzoneMonster","isButton":true,"option":"kidzone newstory"});
	}
	if (items[4]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneAnim.call(items[4] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim);
		(items[4] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).animation = "squishStretch id=kidzoneMonster";
		(items[4] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).isButton = true;
		(items[4] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).option = "kidzone newstory";
		items[4].x = 1440.5;
		items[4].y = 952.2;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch","isButton":true,"option":"dinosaur newstory"});
	}
	if (items[5]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurAnim.call(items[5] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim);
		(items[5] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).animation = "squishStretch";
		(items[5] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).isButton = true;
		(items[5] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).option = "dinosaur newstory";
		items[5].x = 1382.6;
		items[5].y = 1205.4;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[6]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[6] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[6] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[6] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[6] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[6].x = 440;
		items[6].y = 133;
		items[6].width = 1391.90;
		items[6].height = 813.30;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"dance delay=0.4 id=kidzoneMonster","isButton":true,"option":"kidzone danceparty"});
	}
	if (items[7]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneAnim.call(items[7] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim);
		(items[7] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).animation = "dance delay=0.4 id=kidzoneMonster";
		(items[7] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).isButton = true;
		(items[7] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).option = "kidzone danceparty";
		items[7].x = 1440.5;
		items[7].y = 952.2;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"dance delay=0.4 ","isButton":true,"option":"dinosaur danceparty"});
	}
	if (items[8]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurAnim.call(items[8] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim);
		(items[8] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).animation = "dance delay=0.4 ";
		(items[8] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).isButton = true;
		(items[8] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).option = "dinosaur danceparty";
		items[8].x = 1382.6;
		items[8].y = 1205.4;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[9]) {
		ZoraHurstonStoryLayout_hurPlaygroundBg.call(items[9] as IZoraHurstonStoryLayout_hurPlaygroundBg);
		(items[9] as IZoraHurstonStoryLayout_hurPlaygroundBg).animation = "";
		(items[9] as IZoraHurstonStoryLayout_hurPlaygroundBg).isButton = false;
		(items[9] as IZoraHurstonStoryLayout_hurPlaygroundBg).option = "playground";
		items[9].x = 440;
		items[9].y = 133;
		items[9].width = 1391.90;
		items[9].height = 813.30;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"jump delay=0.3 id=kidzoneMonster","isButton":true,"option":"kidzone icecream"});
	}
	if (items[10]) {
		ZoraHurstonStoryLayout_slotEnconterKidzoneAnim.call(items[10] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim);
		(items[10] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).animation = "jump delay=0.3 id=kidzoneMonster";
		(items[10] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).isButton = true;
		(items[10] as IZoraHurstonStoryLayout_slotEnconterKidzoneAnim).option = "kidzone icecream";
		items[10].x = 1440.5;
		items[10].y = 952.2;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"jump delay=0.3","isButton":true,"option":"dinosaur icecream"});
	}
	if (items[11]) {
		ZoraHurstonStoryLayout_slotEnconterDinosaurAnim.call(items[11] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim);
		(items[11] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).animation = "jump delay=0.3";
		(items[11] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).isButton = true;
		(items[11] as IZoraHurstonStoryLayout_slotEnconterDinosaurAnim).option = "dinosaur icecream";
		items[11].x = 1382.6;
		items[11].y = 1205.4;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"isPaperLayer":true});
	}
	if (items[12]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[12] as IZoraHurstonStoryLayout_paperLayer);
		(items[12] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[12].x = 0;
		items[12].y = 0;
		items[12].width = 2048.00;
		items[12].height = 1536.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		ZoraHurstonStoryLayout_slotEnvironment.call(items[13] as IZoraHurstonStoryLayout_slotEnvironment);
		items[13].x = 0;
		items[13].y = 0;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"isPaperLayer":true});
	}
	if (items[14]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[14] as IZoraHurstonStoryLayout_paperLayer);
		(items[14] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[14].x = 0;
		items[14].y = 0;
		items[14].width = 2048.00;
		items[14].height = 1536.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"jump delay=0.3 id=classroomMonster","isButton":true,"option":"classroom jam"});
	}
	if (items[15]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomAnim.call(items[15] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim);
		(items[15] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).animation = "jump delay=0.3 id=classroomMonster";
		(items[15] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).isButton = true;
		(items[15] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).option = "classroom jam";
		items[15].x = 1720.5;
		items[15].y = 892.8;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"jump delay=0.3","isButton":true,"option":"playground jam"});
	}
	if (items[16]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim.call(items[16] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim);
		(items[16] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).animation = "jump delay=0.3";
		(items[16] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).isButton = true;
		(items[16] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).option = "playground jam";
		items[16].x = 1720.65;
		items[16].y = 1111.2;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch id=classroomMonster","isButton":true,"option":"classroom newstory"});
	}
	if (items[17]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomAnim.call(items[17] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim);
		(items[17] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).animation = "squishStretch id=classroomMonster";
		(items[17] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).isButton = true;
		(items[17] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).option = "classroom newstory";
		items[17].x = 1720.5;
		items[17].y = 892.8;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,{"animation":"squishStretch","isButton":true,"option":"playground newstory"});
	}
	if (items[18]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim.call(items[18] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim);
		(items[18] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).animation = "squishStretch";
		(items[18] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).isButton = true;
		(items[18] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).option = "playground newstory";
		items[18].x = 1720.65;
		items[18].y = 1111.2;
		if (items[18].onLayout) items[18].onLayout();
	}
	if (!items[19] && items.elementFactory) {
		items[19] = items.elementFactory(19,{"animation":"dance delay=0.4 id=classroomMonster","isButton":true,"option":"classroom danceparty"});
	}
	if (items[19]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomAnim.call(items[19] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim);
		(items[19] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).animation = "dance delay=0.4 id=classroomMonster";
		(items[19] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).isButton = true;
		(items[19] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).option = "classroom danceparty";
		items[19].x = 1720.5;
		items[19].y = 892.8;
		if (items[19].onLayout) items[19].onLayout();
	}
	if (!items[20] && items.elementFactory) {
		items[20] = items.elementFactory(20,{"animation":"dance delay=0.4 ","isButton":true,"option":"playground danceparty"});
	}
	if (items[20]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim.call(items[20] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim);
		(items[20] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).animation = "dance delay=0.4 ";
		(items[20] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).isButton = true;
		(items[20] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).option = "playground danceparty";
		items[20].x = 1720.65;
		items[20].y = 1111.2;
		if (items[20].onLayout) items[20].onLayout();
	}
	if (!items[21] && items.elementFactory) {
		items[21] = items.elementFactory(21,{"animation":"jump delay=0.3 id=classroomMonster","isButton":true,"option":"classroom icecream"});
	}
	if (items[21]) {
		ZoraHurstonStoryLayout_slotEncounterClassroomAnim.call(items[21] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim);
		(items[21] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).animation = "jump delay=0.3 id=classroomMonster";
		(items[21] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).isButton = true;
		(items[21] as IZoraHurstonStoryLayout_slotEncounterClassroomAnim).option = "classroom icecream";
		items[21].x = 1720.5;
		items[21].y = 892.8;
		if (items[21].onLayout) items[21].onLayout();
	}
	if (!items[22] && items.elementFactory) {
		items[22] = items.elementFactory(22,{"animation":"jump delay=0.3","isButton":true,"option":"playground icecream"});
	}
	if (items[22]) {
		ZoraHurstonStoryLayout_slotEnconterPlaygroundAnim.call(items[22] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim);
		(items[22] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).animation = "jump delay=0.3";
		(items[22] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).isButton = true;
		(items[22] as IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim).option = "playground icecream";
		items[22].x = 1720.65;
		items[22].y = 1111.2;
		if (items[22].onLayout) items[22].onLayout();
	}
	if (!items[23] && items.elementFactory) {
		items[23] = items.elementFactory(23,{"animation":"","isButton":false,"option":"classroom"});
	}
	if (items[23]) {
		ZoraHurstonStoryLayout_slotClassroomTop.call(items[23] as IZoraHurstonStoryLayout_slotClassroomTop);
		(items[23] as IZoraHurstonStoryLayout_slotClassroomTop).animation = "";
		(items[23] as IZoraHurstonStoryLayout_slotClassroomTop).isButton = false;
		(items[23] as IZoraHurstonStoryLayout_slotClassroomTop).option = "classroom";
		items[23].x = 1648.75;
		items[23].y = 1194.65;
		if (items[23].onLayout) items[23].onLayout();
	}
	if (!items[24] && items.elementFactory) {
		items[24] = items.elementFactory(24,{"animation":"","isButton":true,"option":"playground"});
	}
	if (items[24]) {
		ZoraHurstonStoryLayout_hurPlayground1.call(items[24] as IZoraHurstonStoryLayout_hurPlayground1);
		(items[24] as IZoraHurstonStoryLayout_hurPlayground1).animation = "";
		(items[24] as IZoraHurstonStoryLayout_hurPlayground1).isButton = true;
		(items[24] as IZoraHurstonStoryLayout_hurPlayground1).option = "playground";
		items[24].x = 1348.6;
		items[24].y = 1137.25;
		if (items[24].onLayout) items[24].onLayout();
	}
	if (!items[25] && items.elementFactory) {
		items[25] = items.elementFactory(25,{"maskOf":"classroomMonster"});
	}
	if (items[25]) {
		ZoraHurstonStoryLayout_desk_mask.call(items[25] as IZoraHurstonStoryLayout_desk_mask);
		(items[25] as IZoraHurstonStoryLayout_desk_mask).maskOf = "classroomMonster";
		items[25].x = 956.8;
		items[25].y = -70.35;
		if (items[25].onLayout) items[25].onLayout();
	}
	if (!items[26] && items.elementFactory) {
		items[26] = items.elementFactory(26,{"maskOf":"kidzoneMonster"});
	}
	if (items[26]) {
		ZoraHurstonStoryLayout_playground_mask.call(items[26] as IZoraHurstonStoryLayout_playground_mask);
		(items[26] as IZoraHurstonStoryLayout_playground_mask).maskOf = "kidzoneMonster";
		items[26].x = 956.8;
		items[26].y = -70.35;
		if (items[26].onLayout) items[26].onLayout();
	}
	if (!items[27] && items.elementFactory) {
		items[27] = items.elementFactory(27,{"isPaperLayer":true});
	}
	if (items[27]) {
		ZoraHurstonStoryLayout_paperLayer.call(items[27] as IZoraHurstonStoryLayout_paperLayer);
		(items[27] as IZoraHurstonStoryLayout_paperLayer).isPaperLayer = true;
		items[27].x = 0;
		items[27].y = 0;
		items[27].width = 2048.00;
		items[27].height = 1536.00;
		if (items[27].onLayout) items[27].onLayout();
	}
	if (!items[28] && items.elementFactory) {
		items[28] = items.elementFactory(28,{"animation":"","isButton":true,"option":"classroom jam"});
	}
	if (items[28]) {
		ZoraHurstonStoryLayout_hurBHappy1.call(items[28] as IZoraHurstonStoryLayout_hurBHappy1);
		(items[28] as IZoraHurstonStoryLayout_hurBHappy1).animation = "";
		(items[28] as IZoraHurstonStoryLayout_hurBHappy1).isButton = true;
		(items[28] as IZoraHurstonStoryLayout_hurBHappy1).option = "classroom jam";
		items[28].x = 553.8;
		items[28].y = 1098.05;
		if (items[28].onLayout) items[28].onLayout();
	}
	if (!items[29] && items.elementFactory) {
		items[29] = items.elementFactory(29,{"animation":"","isButton":true,"option":"playground jam"});
	}
	if (items[29]) {
		ZoraHurstonStoryLayout_hurBHappy1.call(items[29] as IZoraHurstonStoryLayout_hurBHappy1);
		(items[29] as IZoraHurstonStoryLayout_hurBHappy1).animation = "";
		(items[29] as IZoraHurstonStoryLayout_hurBHappy1).isButton = true;
		(items[29] as IZoraHurstonStoryLayout_hurBHappy1).option = "playground jam";
		items[29].x = 553.1;
		items[29].y = 1097.3;
		if (items[29].onLayout) items[29].onLayout();
	}
	if (!items[30] && items.elementFactory) {
		items[30] = items.elementFactory(30,{"animation":"","isButton":true,"option":"kidzone jam"});
	}
	if (items[30]) {
		ZoraHurstonStoryLayout_hurBHappy1.call(items[30] as IZoraHurstonStoryLayout_hurBHappy1);
		(items[30] as IZoraHurstonStoryLayout_hurBHappy1).animation = "";
		(items[30] as IZoraHurstonStoryLayout_hurBHappy1).isButton = true;
		(items[30] as IZoraHurstonStoryLayout_hurBHappy1).option = "kidzone jam";
		items[30].x = 638.4;
		items[30].y = 1081.65;
		if (items[30].onLayout) items[30].onLayout();
	}
	if (!items[31] && items.elementFactory) {
		items[31] = items.elementFactory(31,{"animation":"","isButton":true,"option":"dinosaur jam"});
	}
	if (items[31]) {
		ZoraHurstonStoryLayout_hurBHappy1.call(items[31] as IZoraHurstonStoryLayout_hurBHappy1);
		(items[31] as IZoraHurstonStoryLayout_hurBHappy1).animation = "";
		(items[31] as IZoraHurstonStoryLayout_hurBHappy1).isButton = true;
		(items[31] as IZoraHurstonStoryLayout_hurBHappy1).option = "dinosaur jam";
		items[31].x = 752.65;
		items[31].y = 927.25;
		if (items[31].onLayout) items[31].onLayout();
	}
	if (!items[32] && items.elementFactory) {
		items[32] = items.elementFactory(32,{"animation":"","isButton":true,"option":"classroom newstory"});
	}
	if (items[32]) {
		ZoraHurstonStoryLayout_hurBSitting1.call(items[32] as IZoraHurstonStoryLayout_hurBSitting1);
		(items[32] as IZoraHurstonStoryLayout_hurBSitting1).animation = "";
		(items[32] as IZoraHurstonStoryLayout_hurBSitting1).isButton = true;
		(items[32] as IZoraHurstonStoryLayout_hurBSitting1).option = "classroom newstory";
		items[32].x = 571.8;
		items[32].y = 1104.05;
		if (items[32].onLayout) items[32].onLayout();
	}
	if (!items[33] && items.elementFactory) {
		items[33] = items.elementFactory(33,{"animation":"","isButton":true,"option":"playground newstory"});
	}
	if (items[33]) {
		ZoraHurstonStoryLayout_hurBSitting1.call(items[33] as IZoraHurstonStoryLayout_hurBSitting1);
		(items[33] as IZoraHurstonStoryLayout_hurBSitting1).animation = "";
		(items[33] as IZoraHurstonStoryLayout_hurBSitting1).isButton = true;
		(items[33] as IZoraHurstonStoryLayout_hurBSitting1).option = "playground newstory";
		items[33].x = 570.65;
		items[33].y = 1105.75;
		if (items[33].onLayout) items[33].onLayout();
	}
	if (!items[34] && items.elementFactory) {
		items[34] = items.elementFactory(34,{"animation":"","isButton":true,"option":"kidzone newstory"});
	}
	if (items[34]) {
		ZoraHurstonStoryLayout_hurBSitting1.call(items[34] as IZoraHurstonStoryLayout_hurBSitting1);
		(items[34] as IZoraHurstonStoryLayout_hurBSitting1).animation = "";
		(items[34] as IZoraHurstonStoryLayout_hurBSitting1).isButton = true;
		(items[34] as IZoraHurstonStoryLayout_hurBSitting1).option = "kidzone newstory";
		items[34].x = 548.25;
		items[34].y = 918.05;
		if (items[34].onLayout) items[34].onLayout();
	}
	if (!items[35] && items.elementFactory) {
		items[35] = items.elementFactory(35,{"animation":"","isButton":true,"option":"dinosaur newstory"});
	}
	if (items[35]) {
		ZoraHurstonStoryLayout_hurBSitting1.call(items[35] as IZoraHurstonStoryLayout_hurBSitting1);
		(items[35] as IZoraHurstonStoryLayout_hurBSitting1).animation = "";
		(items[35] as IZoraHurstonStoryLayout_hurBSitting1).isButton = true;
		(items[35] as IZoraHurstonStoryLayout_hurBSitting1).option = "dinosaur newstory";
		items[35].x = 852.35;
		items[35].y = 929.8;
		if (items[35].onLayout) items[35].onLayout();
	}
	if (!items[36] && items.elementFactory) {
		items[36] = items.elementFactory(36,{"animation":"","isButton":true,"option":"classroom danceparty"});
	}
	if (items[36]) {
		ZoraHurstonStoryLayout_hurBLaugh1.call(items[36] as IZoraHurstonStoryLayout_hurBLaugh1);
		(items[36] as IZoraHurstonStoryLayout_hurBLaugh1).animation = "";
		(items[36] as IZoraHurstonStoryLayout_hurBLaugh1).isButton = true;
		(items[36] as IZoraHurstonStoryLayout_hurBLaugh1).option = "classroom danceparty";
		items[36].x = 562.8;
		items[36].y = 1101.05;
		if (items[36].onLayout) items[36].onLayout();
	}
	if (!items[37] && items.elementFactory) {
		items[37] = items.elementFactory(37,{"animation":"","isButton":true,"option":"playground danceparty"});
	}
	if (items[37]) {
		ZoraHurstonStoryLayout_hurBLaugh1.call(items[37] as IZoraHurstonStoryLayout_hurBLaugh1);
		(items[37] as IZoraHurstonStoryLayout_hurBLaugh1).animation = "";
		(items[37] as IZoraHurstonStoryLayout_hurBLaugh1).isButton = true;
		(items[37] as IZoraHurstonStoryLayout_hurBLaugh1).option = "playground danceparty";
		items[37].x = 563.45;
		items[37].y = 1100.15;
		if (items[37].onLayout) items[37].onLayout();
	}
	if (!items[38] && items.elementFactory) {
		items[38] = items.elementFactory(38,{"animation":"","isButton":true,"option":"kidzone danceparty"});
	}
	if (items[38]) {
		ZoraHurstonStoryLayout_hurBLaugh1.call(items[38] as IZoraHurstonStoryLayout_hurBLaugh1);
		(items[38] as IZoraHurstonStoryLayout_hurBLaugh1).animation = "";
		(items[38] as IZoraHurstonStoryLayout_hurBLaugh1).isButton = true;
		(items[38] as IZoraHurstonStoryLayout_hurBLaugh1).option = "kidzone danceparty";
		items[38].x = 586.3;
		items[38].y = 1097.5;
		if (items[38].onLayout) items[38].onLayout();
	}
	if (!items[39] && items.elementFactory) {
		items[39] = items.elementFactory(39,{"animation":"","isButton":true,"option":"dinosaur danceparty"});
	}
	if (items[39]) {
		ZoraHurstonStoryLayout_hurBLaugh1.call(items[39] as IZoraHurstonStoryLayout_hurBLaugh1);
		(items[39] as IZoraHurstonStoryLayout_hurBLaugh1).animation = "";
		(items[39] as IZoraHurstonStoryLayout_hurBLaugh1).isButton = true;
		(items[39] as IZoraHurstonStoryLayout_hurBLaugh1).option = "dinosaur danceparty";
		items[39].x = 545.5;
		items[39].y = 901.35;
		if (items[39].onLayout) items[39].onLayout();
	}
	if (!items[40] && items.elementFactory) {
		items[40] = items.elementFactory(40,{"animation":"","isButton":true,"option":"classroom icecream"});
	}
	if (items[40]) {
		ZoraHurstonStoryLayout_hurBBigsmile1.call(items[40] as IZoraHurstonStoryLayout_hurBBigsmile1);
		(items[40] as IZoraHurstonStoryLayout_hurBBigsmile1).animation = "";
		(items[40] as IZoraHurstonStoryLayout_hurBBigsmile1).isButton = true;
		(items[40] as IZoraHurstonStoryLayout_hurBBigsmile1).option = "classroom icecream";
		items[40].x = 554;
		items[40].y = 1101.05;
		if (items[40].onLayout) items[40].onLayout();
	}
	if (!items[41] && items.elementFactory) {
		items[41] = items.elementFactory(41,{"animation":"","isButton":true,"option":"playground icecream"});
	}
	if (items[41]) {
		ZoraHurstonStoryLayout_hurBBigsmile1.call(items[41] as IZoraHurstonStoryLayout_hurBBigsmile1);
		(items[41] as IZoraHurstonStoryLayout_hurBBigsmile1).animation = "";
		(items[41] as IZoraHurstonStoryLayout_hurBBigsmile1).isButton = true;
		(items[41] as IZoraHurstonStoryLayout_hurBBigsmile1).option = "playground icecream";
		items[41].x = 554.65;
		items[41].y = 1100.95;
		if (items[41].onLayout) items[41].onLayout();
	}
	if (!items[42] && items.elementFactory) {
		items[42] = items.elementFactory(42,{"animation":"","isButton":true,"option":"kidzone icecream"});
	}
	if (items[42]) {
		ZoraHurstonStoryLayout_hurBBigsmile1.call(items[42] as IZoraHurstonStoryLayout_hurBBigsmile1);
		(items[42] as IZoraHurstonStoryLayout_hurBBigsmile1).animation = "";
		(items[42] as IZoraHurstonStoryLayout_hurBBigsmile1).isButton = true;
		(items[42] as IZoraHurstonStoryLayout_hurBBigsmile1).option = "kidzone icecream";
		items[42].x = 588;
		items[42].y = 1102.6;
		if (items[42].onLayout) items[42].onLayout();
	}
	if (!items[43] && items.elementFactory) {
		items[43] = items.elementFactory(43,{"animation":"","isButton":true,"option":"dinosaur icecream"});
	}
	if (items[43]) {
		ZoraHurstonStoryLayout_hurBBigsmile1.call(items[43] as IZoraHurstonStoryLayout_hurBBigsmile1);
		(items[43] as IZoraHurstonStoryLayout_hurBBigsmile1).animation = "";
		(items[43] as IZoraHurstonStoryLayout_hurBBigsmile1).isButton = true;
		(items[43] as IZoraHurstonStoryLayout_hurBBigsmile1).option = "dinosaur icecream";
		items[43].x = 546.3;
		items[43].y = 907;
		if (items[43].onLayout) items[43].onLayout();
	}
	if (!items[44] && items.elementFactory) {
		items[44] = items.elementFactory(44,{"animation":"","isButton":true,"option":"classroom jam"});
	}
	if (items[44]) {
		ZoraHurstonStoryLayout_hurJam.call(items[44] as IZoraHurstonStoryLayout_hurJam);
		(items[44] as IZoraHurstonStoryLayout_hurJam).animation = "";
		(items[44] as IZoraHurstonStoryLayout_hurJam).isButton = true;
		(items[44] as IZoraHurstonStoryLayout_hurJam).option = "classroom jam";
		items[44].x = 1081.65;
		items[44].y = 1124.5;
		if (items[44].onLayout) items[44].onLayout();
	}
	if (!items[45] && items.elementFactory) {
		items[45] = items.elementFactory(45,{"animation":"","isButton":true,"option":"playground jam"});
	}
	if (items[45]) {
		ZoraHurstonStoryLayout_hurJam.call(items[45] as IZoraHurstonStoryLayout_hurJam);
		(items[45] as IZoraHurstonStoryLayout_hurJam).animation = "";
		(items[45] as IZoraHurstonStoryLayout_hurJam).isButton = true;
		(items[45] as IZoraHurstonStoryLayout_hurJam).option = "playground jam";
		items[45].x = 984.55;
		items[45].y = 1124.5;
		if (items[45].onLayout) items[45].onLayout();
	}
	if (!items[46] && items.elementFactory) {
		items[46] = items.elementFactory(46,{"animation":"","isButton":true,"option":"kidzone jam"});
	}
	if (items[46]) {
		ZoraHurstonStoryLayout_hurJam.call(items[46] as IZoraHurstonStoryLayout_hurJam);
		(items[46] as IZoraHurstonStoryLayout_hurJam).animation = "";
		(items[46] as IZoraHurstonStoryLayout_hurJam).isButton = true;
		(items[46] as IZoraHurstonStoryLayout_hurJam).option = "kidzone jam";
		items[46].x = 1023.95;
		items[46].y = 943.3;
		if (items[46].onLayout) items[46].onLayout();
	}
	if (!items[47] && items.elementFactory) {
		items[47] = items.elementFactory(47,{"animation":"","isButton":true,"option":"dinosaur jam"});
	}
	if (items[47]) {
		ZoraHurstonStoryLayout_hurJam.call(items[47] as IZoraHurstonStoryLayout_hurJam);
		(items[47] as IZoraHurstonStoryLayout_hurJam).animation = "";
		(items[47] as IZoraHurstonStoryLayout_hurJam).isButton = true;
		(items[47] as IZoraHurstonStoryLayout_hurJam).option = "dinosaur jam";
		items[47].x = 1025.65;
		items[47].y = 1052.1;
		if (items[47].onLayout) items[47].onLayout();
	}
	if (!items[48] && items.elementFactory) {
		items[48] = items.elementFactory(48,{"animation":"","isButton":true,"option":"classroom newstory"});
	}
	if (items[48]) {
		ZoraHurstonStoryLayout_hurNewstory.call(items[48] as IZoraHurstonStoryLayout_hurNewstory);
		(items[48] as IZoraHurstonStoryLayout_hurNewstory).animation = "";
		(items[48] as IZoraHurstonStoryLayout_hurNewstory).isButton = true;
		(items[48] as IZoraHurstonStoryLayout_hurNewstory).option = "classroom newstory";
		items[48].x = 1043.35;
		items[48].y = 1151.75;
		if (items[48].onLayout) items[48].onLayout();
	}
	if (!items[49] && items.elementFactory) {
		items[49] = items.elementFactory(49,{"animation":"","isButton":true,"option":"playground newstory"});
	}
	if (items[49]) {
		ZoraHurstonStoryLayout_hurNewstory.call(items[49] as IZoraHurstonStoryLayout_hurNewstory);
		(items[49] as IZoraHurstonStoryLayout_hurNewstory).animation = "";
		(items[49] as IZoraHurstonStoryLayout_hurNewstory).isButton = true;
		(items[49] as IZoraHurstonStoryLayout_hurNewstory).option = "playground newstory";
		items[49].x = 1043.45;
		items[49].y = 1151.55;
		if (items[49].onLayout) items[49].onLayout();
	}
	if (!items[50] && items.elementFactory) {
		items[50] = items.elementFactory(50,{"animation":"","isButton":true,"option":"kidzone newstory"});
	}
	if (items[50]) {
		ZoraHurstonStoryLayout_hurNewstory.call(items[50] as IZoraHurstonStoryLayout_hurNewstory);
		(items[50] as IZoraHurstonStoryLayout_hurNewstory).animation = "";
		(items[50] as IZoraHurstonStoryLayout_hurNewstory).isButton = true;
		(items[50] as IZoraHurstonStoryLayout_hurNewstory).option = "kidzone newstory";
		items[50].x = 1026.6;
		items[50].y = 969.25;
		if (items[50].onLayout) items[50].onLayout();
	}
	if (!items[51] && items.elementFactory) {
		items[51] = items.elementFactory(51,{"animation":"","isButton":true,"option":"dinosaur newstory"});
	}
	if (items[51]) {
		ZoraHurstonStoryLayout_hurNewstory.call(items[51] as IZoraHurstonStoryLayout_hurNewstory);
		(items[51] as IZoraHurstonStoryLayout_hurNewstory).animation = "";
		(items[51] as IZoraHurstonStoryLayout_hurNewstory).isButton = true;
		(items[51] as IZoraHurstonStoryLayout_hurNewstory).option = "dinosaur newstory";
		items[51].x = 1044.7;
		items[51].y = 1035.3;
		if (items[51].onLayout) items[51].onLayout();
	}
	if (!items[52] && items.elementFactory) {
		items[52] = items.elementFactory(52,{"animation":"","isButton":true,"option":"classroom danceparty"});
	}
	if (items[52]) {
		ZoraHurstonStoryLayout_hurDanceparty.call(items[52] as IZoraHurstonStoryLayout_hurDanceparty);
		(items[52] as IZoraHurstonStoryLayout_hurDanceparty).animation = "";
		(items[52] as IZoraHurstonStoryLayout_hurDanceparty).isButton = true;
		(items[52] as IZoraHurstonStoryLayout_hurDanceparty).option = "classroom danceparty";
		items[52].x = 1073.55;
		items[52].y = 1120.85;
		if (items[52].onLayout) items[52].onLayout();
	}
	if (!items[53] && items.elementFactory) {
		items[53] = items.elementFactory(53,{"animation":"","isButton":true,"option":"playground danceparty"});
	}
	if (items[53]) {
		ZoraHurstonStoryLayout_hurDanceparty.call(items[53] as IZoraHurstonStoryLayout_hurDanceparty);
		(items[53] as IZoraHurstonStoryLayout_hurDanceparty).animation = "";
		(items[53] as IZoraHurstonStoryLayout_hurDanceparty).isButton = true;
		(items[53] as IZoraHurstonStoryLayout_hurDanceparty).option = "playground danceparty";
		items[53].x = 1071.2;
		items[53].y = 1149.85;
		if (items[53].onLayout) items[53].onLayout();
	}
	if (!items[54] && items.elementFactory) {
		items[54] = items.elementFactory(54,{"animation":"","isButton":true,"option":"kidzone danceparty"});
	}
	if (items[54]) {
		ZoraHurstonStoryLayout_hurDanceparty.call(items[54] as IZoraHurstonStoryLayout_hurDanceparty);
		(items[54] as IZoraHurstonStoryLayout_hurDanceparty).animation = "";
		(items[54] as IZoraHurstonStoryLayout_hurDanceparty).isButton = true;
		(items[54] as IZoraHurstonStoryLayout_hurDanceparty).option = "kidzone danceparty";
		items[54].x = 1023.8;
		items[54].y = 939.75;
		if (items[54].onLayout) items[54].onLayout();
	}
	if (!items[55] && items.elementFactory) {
		items[55] = items.elementFactory(55,{"animation":"","isButton":true,"option":"dinosaur danceparty"});
	}
	if (items[55]) {
		ZoraHurstonStoryLayout_hurDanceparty.call(items[55] as IZoraHurstonStoryLayout_hurDanceparty);
		(items[55] as IZoraHurstonStoryLayout_hurDanceparty).animation = "";
		(items[55] as IZoraHurstonStoryLayout_hurDanceparty).isButton = true;
		(items[55] as IZoraHurstonStoryLayout_hurDanceparty).option = "dinosaur danceparty";
		items[55].x = 1034.45;
		items[55].y = 1014.8;
		if (items[55].onLayout) items[55].onLayout();
	}
	if (!items[56] && items.elementFactory) {
		items[56] = items.elementFactory(56,{"animation":"","isButton":true,"option":"classroom icecream"});
	}
	if (items[56]) {
		ZoraHurstonStoryLayout_hurIcecream.call(items[56] as IZoraHurstonStoryLayout_hurIcecream);
		(items[56] as IZoraHurstonStoryLayout_hurIcecream).animation = "";
		(items[56] as IZoraHurstonStoryLayout_hurIcecream).isButton = true;
		(items[56] as IZoraHurstonStoryLayout_hurIcecream).option = "classroom icecream";
		items[56].x = 1073.4;
		items[56].y = 1136.45;
		if (items[56].onLayout) items[56].onLayout();
	}
	if (!items[57] && items.elementFactory) {
		items[57] = items.elementFactory(57,{"animation":"","isButton":true,"option":"playground icecream"});
	}
	if (items[57]) {
		ZoraHurstonStoryLayout_hurIcecream.call(items[57] as IZoraHurstonStoryLayout_hurIcecream);
		(items[57] as IZoraHurstonStoryLayout_hurIcecream).animation = "";
		(items[57] as IZoraHurstonStoryLayout_hurIcecream).isButton = true;
		(items[57] as IZoraHurstonStoryLayout_hurIcecream).option = "playground icecream";
		items[57].x = 1069.25;
		items[57].y = 1196.6;
		if (items[57].onLayout) items[57].onLayout();
	}
	if (!items[58] && items.elementFactory) {
		items[58] = items.elementFactory(58,{"animation":"","isButton":true,"option":"kidzone icecream"});
	}
	if (items[58]) {
		ZoraHurstonStoryLayout_hurIcecream.call(items[58] as IZoraHurstonStoryLayout_hurIcecream);
		(items[58] as IZoraHurstonStoryLayout_hurIcecream).animation = "";
		(items[58] as IZoraHurstonStoryLayout_hurIcecream).isButton = true;
		(items[58] as IZoraHurstonStoryLayout_hurIcecream).option = "kidzone icecream";
		items[58].x = 1024.3;
		items[58].y = 943.25;
		if (items[58].onLayout) items[58].onLayout();
	}
	if (!items[59] && items.elementFactory) {
		items[59] = items.elementFactory(59,{"animation":"","isButton":true,"option":"dinosaur icecream"});
	}
	if (items[59]) {
		ZoraHurstonStoryLayout_hurIcecream.call(items[59] as IZoraHurstonStoryLayout_hurIcecream);
		(items[59] as IZoraHurstonStoryLayout_hurIcecream).animation = "";
		(items[59] as IZoraHurstonStoryLayout_hurIcecream).isButton = true;
		(items[59] as IZoraHurstonStoryLayout_hurIcecream).option = "dinosaur icecream";
		items[59].x = 994.7;
		items[59].y = 1039.35;
		if (items[59].onLayout) items[59].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBHappy1(this: IZoraHurstonStoryLayout_hurBHappy1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"jump delay=0.3","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBHappy.call(items[0] as IZoraHurstonStoryLayout_hurBHappy);
		(items[0] as IZoraHurstonStoryLayout_hurBHappy).animation = "jump delay=0.3";
		(items[0] as IZoraHurstonStoryLayout_hurBHappy).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurBHappy).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 317.00;
		items[0].height = 523.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBHappy(this: IZoraHurstonStoryLayout_hurBHappy) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-happy.png", 0.502, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurBSitting1(this: IZoraHurstonStoryLayout_hurBSitting1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBSitting.call(items[0] as IZoraHurstonStoryLayout_hurBSitting);
		(items[0] as IZoraHurstonStoryLayout_hurBSitting).animation = "squishStretch";
		(items[0] as IZoraHurstonStoryLayout_hurBSitting).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurBSitting).option = "";
		items[0].x = 0.5;
		items[0].y = 0;
		items[0].width = 289.00;
		items[0].height = 455.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBSitting(this: IZoraHurstonStoryLayout_hurBSitting) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-sitting.png", 0.502, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurBLaugh1(this: IZoraHurstonStoryLayout_hurBLaugh1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBLaugh.call(items[0] as IZoraHurstonStoryLayout_hurBLaugh);
		(items[0] as IZoraHurstonStoryLayout_hurBLaugh).animation = "squishStretch";
		(items[0] as IZoraHurstonStoryLayout_hurBLaugh).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurBLaugh).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 334.00;
		items[0].height = 523.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBLaugh(this: IZoraHurstonStoryLayout_hurBLaugh) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-laugh.png", 0.500, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurBBigsmile1(this: IZoraHurstonStoryLayout_hurBBigsmile1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"jump delay=0.3","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurBBigsmile.call(items[0] as IZoraHurstonStoryLayout_hurBBigsmile);
		(items[0] as IZoraHurstonStoryLayout_hurBBigsmile).animation = "jump delay=0.3";
		(items[0] as IZoraHurstonStoryLayout_hurBBigsmile).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurBBigsmile).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 371.00;
		items[0].height = 536.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurBBigsmile(this: IZoraHurstonStoryLayout_hurBBigsmile) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-b-bigsmile.png", 0.501, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurJam(this: IZoraHurstonStoryLayout_hurJam) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"drop","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurJam1.call(items[0] as IZoraHurstonStoryLayout_hurJam1);
		(items[0] as IZoraHurstonStoryLayout_hurJam1).animation = "drop";
		(items[0] as IZoraHurstonStoryLayout_hurJam1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurJam1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 456.00;
		items[0].height = 481.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurJam1(this: IZoraHurstonStoryLayout_hurJam1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-jam.png", 0.500, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurNewstory(this: IZoraHurstonStoryLayout_hurNewstory) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"drop delay=0.4","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurNewstory1.call(items[0] as IZoraHurstonStoryLayout_hurNewstory1);
		(items[0] as IZoraHurstonStoryLayout_hurNewstory1).animation = "drop delay=0.4";
		(items[0] as IZoraHurstonStoryLayout_hurNewstory1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurNewstory1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurNewstory1(this: IZoraHurstonStoryLayout_hurNewstory1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurNewstoryBook.call(items[0] as IZoraHurstonStoryLayout_hurNewstoryBook);
		(items[0] as IZoraHurstonStoryLayout_hurNewstoryBook).animation = "";
		(items[0] as IZoraHurstonStoryLayout_hurNewstoryBook).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurNewstoryBook).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 583.00;
		items[0].height = 122.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"flip appear delay=0.8","isButton":false,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurNewstoryCrayon.call(items[1] as IZoraHurstonStoryLayout_hurNewstoryCrayon);
		(items[1] as IZoraHurstonStoryLayout_hurNewstoryCrayon).animation = "flip appear delay=0.8";
		(items[1] as IZoraHurstonStoryLayout_hurNewstoryCrayon).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurNewstoryCrayon).option = "";
		items[1].x = 117;
		items[1].y = -138;
		items[1].width = 68.00;
		items[1].height = 144.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurNewstoryBook(this: IZoraHurstonStoryLayout_hurNewstoryBook) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-newstory-book.png", 0.501, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurNewstoryCrayon(this: IZoraHurstonStoryLayout_hurNewstoryCrayon) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-newstory-crayon.png", 0.500, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_hurDanceparty(this: IZoraHurstonStoryLayout_hurDanceparty) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"slideIn left delay=0.2 time=0.4 ease=sineOut","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDanceparty1.call(items[0] as IZoraHurstonStoryLayout_hurDanceparty1);
		(items[0] as IZoraHurstonStoryLayout_hurDanceparty1).animation = "slideIn left delay=0.2 time=0.4 ease=sineOut";
		(items[0] as IZoraHurstonStoryLayout_hurDanceparty1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurDanceparty1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDanceparty1(this: IZoraHurstonStoryLayout_hurDanceparty1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"pulse speed=0.96","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDanceparty2.call(items[0] as IZoraHurstonStoryLayout_hurDanceparty2);
		(items[0] as IZoraHurstonStoryLayout_hurDanceparty2).animation = "pulse speed=0.96";
		(items[0] as IZoraHurstonStoryLayout_hurDanceparty2).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurDanceparty2).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"pulse","isButton":false,"option":""});
	}
	if (items[1]) {
		ZoraHurstonStoryLayout_hurDancepartySpeakerright.call(items[1] as IZoraHurstonStoryLayout_hurDancepartySpeakerright);
		(items[1] as IZoraHurstonStoryLayout_hurDancepartySpeakerright).animation = "pulse";
		(items[1] as IZoraHurstonStoryLayout_hurDancepartySpeakerright).isButton = false;
		(items[1] as IZoraHurstonStoryLayout_hurDancepartySpeakerright).option = "";
		items[1].x = 117;
		items[1].y = -69.95;
		items[1].width = 136.40;
		items[1].height = 135.30;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"pulse","isButton":false,"option":""});
	}
	if (items[2]) {
		ZoraHurstonStoryLayout_hurDancepartySpeakerleft.call(items[2] as IZoraHurstonStoryLayout_hurDancepartySpeakerleft);
		(items[2] as IZoraHurstonStoryLayout_hurDancepartySpeakerleft).animation = "pulse";
		(items[2] as IZoraHurstonStoryLayout_hurDancepartySpeakerleft).isButton = false;
		(items[2] as IZoraHurstonStoryLayout_hurDancepartySpeakerleft).option = "";
		items[2].x = -126.75;
		items[2].y = -69.95;
		items[2].width = 135.30;
		items[2].height = 127.60;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDanceparty2(this: IZoraHurstonStoryLayout_hurDanceparty2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurDanceparty3.call(items[0] as IZoraHurstonStoryLayout_hurDanceparty3);
		items[0].x = -0.5;
		items[0].y = 0;
		items[0].width = 401.00;
		items[0].height = 270.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurDanceparty3(this: IZoraHurstonStoryLayout_hurDanceparty3) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-danceparty.png", 0.500, 1.000);
	return this;
}
function ZoraHurstonStoryLayout_hurDancepartySpeakerright(this: IZoraHurstonStoryLayout_hurDancepartySpeakerright) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-danceparty-speakerright.png", 0.500, 0.504);
	return this;
}
function ZoraHurstonStoryLayout_hurDancepartySpeakerleft(this: IZoraHurstonStoryLayout_hurDancepartySpeakerleft) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-danceparty-speakerleft.png", 0.504, 0.500);
	return this;
}
function ZoraHurstonStoryLayout_hurIcecream(this: IZoraHurstonStoryLayout_hurIcecream) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"drop","isButton":false,"option":""});
	}
	if (items[0]) {
		ZoraHurstonStoryLayout_hurIcecream1.call(items[0] as IZoraHurstonStoryLayout_hurIcecream1);
		(items[0] as IZoraHurstonStoryLayout_hurIcecream1).animation = "drop";
		(items[0] as IZoraHurstonStoryLayout_hurIcecream1).isButton = false;
		(items[0] as IZoraHurstonStoryLayout_hurIcecream1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 512.00;
		items[0].height = 653.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function ZoraHurstonStoryLayout_hurIcecream1(this: IZoraHurstonStoryLayout_hurIcecream1) {
	if (this.setLayoutTexture) this.setLayoutTexture("hur-icecream.png", 0.500, 1.000);
	return this;
}
interface IZoraHurstonStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IZoraHurstonStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IZoraHurstonStoryLayoutSprite extends IZoraHurstonStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IZoraHurstonStoryLayoutText extends IZoraHurstonStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IZoraHurstonStoryLayoutPolygon extends Array<number> {
}
interface IZoraHurstonStoryLayout {
	readonly scene1Start: IZoraHurstonStoryLayout_scene1Start;
	readonly scene2Encounter: IZoraHurstonStoryLayout_scene2Encounter;
	readonly scene3Reaction: IZoraHurstonStoryLayout_scene3Reaction;
	readonly scene4Help: IZoraHurstonStoryLayout_scene4Help;
	readonly scene5Result: IZoraHurstonStoryLayout_scene5Result;
	readonly scene6End: IZoraHurstonStoryLayout_scene6End;
}
interface IZoraHurstonStoryLayout_scene1Start extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBg|IZoraHurstonStoryLayout_paperLayer|IZoraHurstonStoryLayout_slotClassroom|IZoraHurstonStoryLayout_hurPlayground11|IZoraHurstonStoryLayout_hurKidzone|IZoraHurstonStoryLayout_hurDinosaur|IZoraHurstonStoryLayout_hurBSitdraw1>;
}
interface IZoraHurstonStoryLayout_hurPlaygroundBg extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_paperLayer extends IZoraHurstonStoryLayoutContainer {
	isPaperLayer: boolean;
}
interface IZoraHurstonStoryLayout_slotClassroom extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotChalkboard|IZoraHurstonStoryLayout_hurClassroomChair|IZoraHurstonStoryLayout_slotDesk|IZoraHurstonStoryLayout_slotPlant>;
	option: string;
}
interface IZoraHurstonStoryLayout_slotChalkboard extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurClassroomChalkboard>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurClassroomChalkboard extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurClassroomChair extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotDesk extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurClassroomDesk>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurClassroomDesk extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_slotPlant extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurClassroomPlant>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurClassroomPlant extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurPlayground11 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBench1|IZoraHurstonStoryLayout_hurPlaygroundStructure1|IZoraHurstonStoryLayout_hurPlaygroundDuck>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurPlaygroundBench1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBench>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurPlaygroundBench extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurPlaygroundStructure1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundStructure>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurPlaygroundStructure extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurPlaygroundDuck extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlayground1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurPlayground1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlayground2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurPlayground2 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurKidzone extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurKidzone1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurKidzone1 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurDinosaur extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDinosaur1|IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDinosaur1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDinosaur2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDinosaur2 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDinosaurexhibitPterodactyl1 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurBSitdraw1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSitdraw>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSitdraw extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_scene2Encounter extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBg|IZoraHurstonStoryLayout_slotEnconterKidzoneAnim|IZoraHurstonStoryLayout_slotEnconterDinosaurAnim|IZoraHurstonStoryLayout_paperLayer|IZoraHurstonStoryLayout_slotEnvironment|IZoraHurstonStoryLayout_slotEncounterClassroomAnim|IZoraHurstonStoryLayout_slotClassroomTop|IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim|IZoraHurstonStoryLayout_hurPlayground1|IZoraHurstonStoryLayout_hurOctopus12|IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_desk_mask|IZoraHurstonStoryLayout_playground_mask|IZoraHurstonStoryLayout_hurBSitdsurprised1|IZoraHurstonStoryLayout_hurDinoBook1Anim>;
}
interface IZoraHurstonStoryLayout_slotEnconterKidzoneAnim extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurOctopus11 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurChest1|IZoraHurstonStoryLayout_hurOctopus1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurChest1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurChest>;
}
interface IZoraHurstonStoryLayout_hurChest extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurOctopus1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus>;
}
interface IZoraHurstonStoryLayout_hurOctopus extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurMummy extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurMummy1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurMummy1 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurMoose extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurMoose1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurMoose1 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurKnight extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurKnight1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurKnight1 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_slotEnconterDinosaurAnim extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnvironment extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotClassroom1|IZoraHurstonStoryLayout_hurPlayground|IZoraHurstonStoryLayout_hurKidzone|IZoraHurstonStoryLayout_hurDinosaur>;
}
interface IZoraHurstonStoryLayout_slotClassroom1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotChalkboard|IZoraHurstonStoryLayout_hurClassroomChair>;
	option: string;
}
interface IZoraHurstonStoryLayout_hurPlayground extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBench1|IZoraHurstonStoryLayout_hurPlaygroundStructure1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEncounterClassroomAnim extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus12|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight|IZoraHurstonStoryLayout_hurMummy>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurOctopus12 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotClassroomTop extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotDesk|IZoraHurstonStoryLayout_slotPlant>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_desk_mask extends IZoraHurstonStoryLayoutContainer {
	readonly maskPoints: IZoraHurstonStoryLayout_desk_maskPoints;
	maskOf: string;
}
interface IZoraHurstonStoryLayout_desk_maskPoints extends IZoraHurstonStoryLayoutPolygon {
}
interface IZoraHurstonStoryLayout_playground_mask extends IZoraHurstonStoryLayoutContainer {
	readonly maskPoints: IZoraHurstonStoryLayout_playground_maskPoints;
	maskOf: string;
}
interface IZoraHurstonStoryLayout_playground_maskPoints extends IZoraHurstonStoryLayoutPolygon {
}
interface IZoraHurstonStoryLayout_hurBSitdsurprised1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSitdsurprised>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSitdsurprised extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurDinoBook1Anim extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDinoBook>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDinoBook extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_scene3Reaction extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotEncountersBack|IZoraHurstonStoryLayout_paperLayer|IZoraHurstonStoryLayout_slotEnvironment|IZoraHurstonStoryLayout_slotEncountersFront|IZoraHurstonStoryLayout_hurPlayground1|IZoraHurstonStoryLayout_hurDinoBook1|IZoraHurstonStoryLayout_slotBradReaction>;
}
interface IZoraHurstonStoryLayout_slotEncountersBack extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBg|IZoraHurstonStoryLayout_slotEnconterKidzone|IZoraHurstonStoryLayout_slotEnconterDinosaur|IZoraHurstonStoryLayout_playground_mask>;
}
interface IZoraHurstonStoryLayout_slotEnconterKidzone extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnconterDinosaur extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEncountersFront extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotEncounterClassroom|IZoraHurstonStoryLayout_slotClassroomTop|IZoraHurstonStoryLayout_slotEnconterPlayground|IZoraHurstonStoryLayout_desk_mask>;
}
interface IZoraHurstonStoryLayout_slotEncounterClassroom extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus12|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight|IZoraHurstonStoryLayout_hurMummy>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnconterPlayground extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDinoBook1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDinoBook>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotBradReaction extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSad1|IZoraHurstonStoryLayout_hurBNervous1|IZoraHurstonStoryLayout_hurBBrave1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSad1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSad>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSad extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurBNervous1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBNervous>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBNervous extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurBBrave1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBBrave>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBBrave extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_scene4Help extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBg|IZoraHurstonStoryLayout_slotEnconterKidzoneAnim|IZoraHurstonStoryLayout_slotEnconterDinosaurAnim|IZoraHurstonStoryLayout_paperLayer|IZoraHurstonStoryLayout_slotEnvironment|IZoraHurstonStoryLayout_slotEncounterClassroomAnim|IZoraHurstonStoryLayout_slotClassroomTop|IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim|IZoraHurstonStoryLayout_hurPlayground1|IZoraHurstonStoryLayout_desk_mask|IZoraHurstonStoryLayout_playground_mask|IZoraHurstonStoryLayout_slotBradShare>;
}
interface IZoraHurstonStoryLayout_slotBradShare extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBShare1|IZoraHurstonStoryLayout_hurStoryBikeman1|IZoraHurstonStoryLayout_hurStoryCape1|IZoraHurstonStoryLayout_hurStoryAgentchaos1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBShare1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBShare>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBShare extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurStoryBikeman1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurStoryBikeman>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurStoryBikeman extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurStoryCape1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurStoryCape>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurStoryCape extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurStoryAgentchaos1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurStoryAgentchaos>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurStoryAgentchaos extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_scene5Result extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBg|IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech|IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech|IZoraHurstonStoryLayout_paperLayer|IZoraHurstonStoryLayout_slotEnvironment|IZoraHurstonStoryLayout_slotEncounterClassroomSpeech|IZoraHurstonStoryLayout_slotClassroomTop|IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech|IZoraHurstonStoryLayout_hurPlayground1|IZoraHurstonStoryLayout_slotEnconterDinosaurBubble|IZoraHurstonStoryLayout_desk_mask|IZoraHurstonStoryLayout_playground_mask|IZoraHurstonStoryLayout_slotBradEat>;
}
interface IZoraHurstonStoryLayout_slotEnconterKidzoneSpeech extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight|IZoraHurstonStoryLayout_slotThoughtBubble>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotThoughtBubble extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurThoughtBubble|IZoraHurstonStoryLayout_hurEmojiHappy|IZoraHurstonStoryLayout_hurEmojiSilly|IZoraHurstonStoryLayout_hurEmojiHungry>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurThoughtBubble extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurEmojiHappy extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurEmojiSilly extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurEmojiHungry extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnconterDinosaurSpeech extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEncounterClassroomSpeech extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus12|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_slotThoughtBubble>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnconterPlaygroundSpeech extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurOctopus11|IZoraHurstonStoryLayout_hurMummy|IZoraHurstonStoryLayout_hurMoose|IZoraHurstonStoryLayout_hurKnight|IZoraHurstonStoryLayout_slotThoughtBubble>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotEnconterDinosaurBubble extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_slotThoughtBubble>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_slotBradEat extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSnacking1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSnacking1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSnacking>;
}
interface IZoraHurstonStoryLayout_hurBSnacking extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_scene6End extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurPlaygroundBg|IZoraHurstonStoryLayout_slotEnconterKidzoneAnim|IZoraHurstonStoryLayout_slotEnconterDinosaurAnim|IZoraHurstonStoryLayout_paperLayer|IZoraHurstonStoryLayout_slotEnvironment|IZoraHurstonStoryLayout_slotEncounterClassroomAnim|IZoraHurstonStoryLayout_slotEnconterPlaygroundAnim|IZoraHurstonStoryLayout_slotClassroomTop|IZoraHurstonStoryLayout_hurPlayground1|IZoraHurstonStoryLayout_desk_mask|IZoraHurstonStoryLayout_playground_mask|IZoraHurstonStoryLayout_hurBHappy1|IZoraHurstonStoryLayout_hurBSitting1|IZoraHurstonStoryLayout_hurBLaugh1|IZoraHurstonStoryLayout_hurBBigsmile1|IZoraHurstonStoryLayout_hurJam|IZoraHurstonStoryLayout_hurNewstory|IZoraHurstonStoryLayout_hurDanceparty|IZoraHurstonStoryLayout_hurIcecream>;
}
interface IZoraHurstonStoryLayout_hurBHappy1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBHappy>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBHappy extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSitting1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBSitting>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBSitting extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBLaugh1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBLaugh>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBLaugh extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBBigsmile1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurBBigsmile>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurBBigsmile extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurJam extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurJam1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurJam1 extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurNewstory extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurNewstory1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurNewstory1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurNewstoryBook|IZoraHurstonStoryLayout_hurNewstoryCrayon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurNewstoryBook extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurNewstoryCrayon extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDanceparty extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDanceparty1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDanceparty1 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDanceparty2|IZoraHurstonStoryLayout_hurDancepartySpeakerright|IZoraHurstonStoryLayout_hurDancepartySpeakerleft>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDanceparty2 extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurDanceparty3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDanceparty3 extends IZoraHurstonStoryLayoutSprite {
}
interface IZoraHurstonStoryLayout_hurDancepartySpeakerright extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurDancepartySpeakerleft extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurIcecream extends IZoraHurstonStoryLayoutContainer {
	readonly items: IZoraHurstonStoryLayoutArray<IZoraHurstonStoryLayout_hurIcecream1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IZoraHurstonStoryLayout_hurIcecream1 extends IZoraHurstonStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
